<template>
  <div>
    <h1>Alumnos</h1>
    <div style="display: flex; gap: 1rem; margin-bottom: 1.5rem; align-items: flex-end; flex-wrap: wrap;">
      <!-- BÚSQUEDA POR NOMBRE (automática) -->
      <div style="display: flex; gap: 0.5rem; align-items: flex-end;">
        <div>
        <input
          v-model="filtros.nombre"
          @input="filtros.nombre = removerTildes($event.target.value); buscarAlumnos()"
          placeholder="Buscar por nombre"
          style="padding: 0.4rem; border-radius: 4px; width: 200px; text-transform: uppercase;"
        />
        </div>
        <button @click="buscarAlumnos" style="background: #007bff; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">🔍</button>
      </div>
      
      <!-- FILTROS -->
      <div style="position: relative;">
        <select v-model="filtros.idtaller" style="padding: 0.8rem 0.4rem 0.4rem 0.4rem; border: 1px solid #ccc; border-radius: 4px; width: 180px; font-size: 0.9rem;">
          <option value="">Todos</option>
          <option v-for="taller in talleres" :key="taller.id" :value="taller.id">{{ taller.descripcion }}</option>
        </select>
        <label style="position: absolute; left: 0.4rem; top: -0.5rem; background: white; padding: 0 0.2rem; font-size: 0.75rem; font-weight: 600; color: #495057; transition: all 0.2s;">Taller</label>
      </div>
      <div style="position: relative;">
        <select v-model="filtros.idnivelacademico" @change="cargarGrados" style="padding: 0.8rem 0.4rem 0.4rem 0.4rem; border: 1px solid #ccc; border-radius: 4px; width: 160px; font-size: 0.9rem;">
          <option value="">Todos</option>
          <option v-for="nivel in niveles" :key="nivel.id" :value="nivel.id">{{ nivel.nivel }}</option>
        </select>
        <label style="position: absolute; left: 0.4rem; top: -0.5rem; background: white; padding: 0 0.2rem; font-size: 0.75rem; font-weight: 600; color: #495057; transition: all 0.2s;">Nivel académico</label>
      </div>
      <div style="position: relative;">
        <select v-model="filtros.idgrado" style="padding: 0.8rem 0.4rem 0.4rem 0.4rem; border: 1px solid #ccc; border-radius: 4px; width: 120px; font-size: 0.9rem;">
          <option value="">Todos</option>
          <option v-for="grado in grados" :key="grado.id" :value="grado.id">{{ grado.grado }}</option>
        </select>
        <label style="position: absolute; left: 0.4rem; top: -0.5rem; background: white; padding: 0 0.2rem; font-size: 0.75rem; font-weight: 600; color: #495057; transition: all 0.2s;">Grado</label>
      </div>
      <button @click="aplicarFiltros" style="background: #6f42c1; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">Filtrar</button>
      <button @click="manejarListaAsistencia" style="background: #28a745; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">Lista de asistencia</button>
      <button @click="generarHorarios" style="background: #17a2b8; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">Horarios</button>
      <button @click="abrirModalAgregar" style="background: #6c757d; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">+ Agregar Alumno</button>
    </div>

    <!-- Contador de Total -->
    <div style="margin-bottom: 1rem; display: flex; justify-content: flex-end;">
      <div style="padding: 0.4rem 0.8rem; background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
        <span style="font-size: 0.85rem; font-weight: 600; color: #495057;">
          Total Alumnos: {{ total }}
        </span>
      </div>
    </div>

    <div class="tabla-responsive">
      <table class="tabla-alumnos-principal">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Nivel</th>
            <th>Grado</th>
            <th>Informacion Tutor</th>
            <th>Talleres</th>
            <th style="text-align:center;">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="alumno in alumnos" :key="alumno.id">
            <td>{{ alumno.nombre }}</td>
            <td>{{ alumno.nivel }}</td>
            <td>{{ alumno.grado }}</td>
            <td>
              <div><strong>{{ alumno.nombretutor }}</strong> <span style="color:#888;">{{ alumno.telefonotutor }}</span></div>
              <div v-if="alumno.nombretutor2"><strong>{{ alumno.nombretutor2 }}</strong> <span style="color:#888;">{{ alumno.telefonotutor2 }}</span></div>
            </td>
            <td>
              <div v-for="taller in alumno.talleres" :key="taller.idGrupo" style="margin-bottom:0.5rem;">
                <span style="font-weight:600; color:#007bff;">{{ taller.taller }}</span>
                <span v-for="h in taller.horariosDias" :key="h.idHorario + '-' + h.idDia" style="background:#f1f3f4; border-radius:3px; margin-left:0.3em; padding:0.1em 0.4em; font-size:0.8em;">
                  {{ h.Dia }} {{ h.horaInicio }}-{{ h.horaFinal }}
                </span>
              </div>
            </td>
            <td style="text-align:center;">
              <div style="display: flex; gap: 0.5rem; justify-content: center; flex-wrap: wrap;">
                <button @click="verDetallesAlumno(alumno)" 
                        style="background: #17a2b8; color: white; border: none; padding: 0.4rem 0.6rem; border-radius: 4px; font-size: 0.85rem;" 
                        title="Ver detalles">
                  👁️
                </button>
                <button v-if="puedeModificarAlumno" @click="abrirModalEditar(alumno)" 
                        style="background: #ffc107; color: white; border: none; padding: 0.4rem 0.6rem; border-radius: 4px; font-size: 0.85rem;" 
                        title="Editar alumno">
                  ✏️
                </button>
                <button v-if="puedeEliminarAlumno" @click="eliminarAlumno(alumno.id)" 
                        style="background: #dc3545; color: white; border: none; padding: 0.4rem 0.6rem; border-radius: 4px; font-size: 0.85rem;" 
                        title="Eliminar alumno">
                  🗑️
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="alumnos.length === 0">
            <td colspan="6" style="text-align:center; padding: 2rem; color: #6c757d; font-style: italic;">No hay alumnos registrados</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-top:1rem;">
      <button :disabled="page === 1" @click="cambiarPagina(page-1)">Anterior</button>
      Página {{ page }} de {{ totalPages }}
      <button :disabled="page === totalPages" @click="cambiarPagina(page+1)">Siguiente</button>
    </div>

    <!-- Card de Conteo por Nivel Académico -->
    <div class="conteo-niveles-card" style="margin-top: 2rem; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 12px; padding: 1.5rem; color: white; box-shadow: 0 8px 25px rgba(0,0,0,0.15);">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
        <h3 style="margin: 0; color: white; font-size: 1.4rem; font-weight: 600;">📊 Conteo de Alumnos por Nivel Académico</h3>
        <button @click="cargarConteoNiveles" :disabled="cargandoConteo" 
                style="background: rgba(255,255,255,0.2); color: white; border: 1px solid rgba(255,255,255,0.3); padding: 0.5rem 1rem; border-radius: 6px; font-weight: 500; cursor: pointer; transition: all 0.3s ease;" 
                onmouseover="this.style.background='rgba(255,255,255,0.3)'" onmouseout="this.style.background='rgba(255,255,255,0.2)'">
          <span v-if="cargandoConteo">⏳ Actualizando...</span>
          <span v-else>🔄 Actualizar</span>
        </button>
      </div>
      
      <div v-if="cargandoConteo" style="text-align: center; padding: 2rem; color: rgba(255,255,255,0.9);">
        <div style="animation: pulse 1.5s infinite;">⏳ Cargando conteo de niveles académicos...</div>
      </div>
      
      <div v-else-if="conteoNiveles.length === 0" style="text-align: center; padding: 2rem; color: rgba(255,255,255,0.8); font-style: italic;">
        📈 Haz clic en "Actualizar" para cargar el conteo de alumnos por nivel
      </div>
      
      <div v-else class="niveles-grid-conteo" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
        <div v-for="nivel in conteoNiveles" :key="nivel.id" class="nivel-conteo-item" 
             @click="filtrarPorNivel(nivel.id)" 
             style="background: rgba(255,255,255,0.15); border-radius: 8px; padding: 1.2rem; cursor: pointer; transition: all 0.3s ease; border: 1px solid rgba(255,255,255,0.2);" 
             onmouseover="this.style.background='rgba(255,255,255,0.25)'; this.style.transform='translateY(-2px)'" 
             onmouseout="this.style.background='rgba(255,255,255,0.15)'; this.style.transform='translateY(0)'">
          <div style="font-size: 1.1rem; font-weight: 600; margin-bottom: 0.5rem; color: #fff;">{{ nivel.nivel }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="font-size: 2rem; font-weight: 700; color: #fff;">{{ nivel.cantidad }}</div>
            <div style="font-size: 0.85rem; color: rgba(255,255,255,0.8); text-align: right;">
              {{ calcularPorcentajeConteo(nivel.cantidad) }}%
              <br>
              <span style="font-size: 0.75rem;">del total</span>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="conteoNiveles.length > 0" style="margin-top: 1rem; text-align: center; font-size: 0.9rem; color: rgba(255,255,255,0.7);">
        💡 Haz clic en un nivel para filtrar la tabla y ver conteo por grados
      </div>
    </div>

    <!-- Card de Conteo por Grados (cuando se selecciona un nivel) -->
    <div v-if="mostrarConteoGrados" class="conteo-grados-card" style="margin-top: 1.5rem; background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); border-radius: 12px; padding: 1.5rem; color: white; box-shadow: 0 8px 25px rgba(0,0,0,0.15);">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
        <h3 style="margin: 0; color: white; font-size: 1.3rem; font-weight: 600;">📈 Conteo por Grados - {{ nivelSeleccionado && nivelSeleccionado.nivel }}</h3>
        <div style="display: flex; gap: 0.5rem;">
          <button @click="cerrarConteoGrados" 
                  style="background: rgba(255,255,255,0.2); color: white; border: 1px solid rgba(255,255,255,0.3); padding: 0.4rem 0.8rem; border-radius: 6px; font-weight: 500; cursor: pointer; transition: all 0.3s ease;" 
                  onmouseover="this.style.background='rgba(255,255,255,0.3)'" onmouseout="this.style.background='rgba(255,255,255,0.2)'">
            ❌ Cerrar
          </button>
          <button @click="cargarConteoGrados" :disabled="cargandoConteoGrados" 
                  style="background: rgba(255,255,255,0.2); color: white; border: 1px solid rgba(255,255,255,0.3); padding: 0.4rem 0.8rem; border-radius: 6px; font-weight: 500; cursor: pointer; transition: all 0.3s ease;" 
                  onmouseover="this.style.background='rgba(255,255,255,0.3)'" onmouseout="this.style.background='rgba(255,255,255,0.2)'">
            <span v-if="cargandoConteoGrados">⏳ Actualizando...</span>
            <span v-else>🔄 Actualizar</span>
          </button>
        </div>
      </div>
      
      <div v-if="cargandoConteoGrados" style="text-align: center; padding: 2rem; color: rgba(255,255,255,0.9);">
        <div style="animation: pulse 1.5s infinite;">⏳ Cargando conteo de grados...</div>
      </div>
      
      <div v-else-if="conteoGrados.length === 0" style="text-align: center; padding: 2rem; color: rgba(255,255,255,0.8); font-style: italic;">
        📊 No hay grados disponibles para este nivel
      </div>
      
      <div v-else class="grados-grid-conteo" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
        <div v-for="grado in conteoGrados" :key="grado.id" class="grado-conteo-item" 
             @click="filtrarPorGrado(grado.id)" 
             style="background: rgba(255,255,255,0.15); border-radius: 8px; padding: 1rem; cursor: pointer; transition: all 0.3s ease; border: 1px solid rgba(255,255,255,0.2);" 
             onmouseover="this.style.background='rgba(255,255,255,0.25)'; this.style.transform='translateY(-2px)'" 
             onmouseout="this.style.background='rgba(255,255,255,0.15)'; this.style.transform='translateY(0)'">
          <div style="font-size: 1rem; font-weight: 600; margin-bottom: 0.4rem; color: #fff;">{{ grado.grado }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="font-size: 1.8rem; font-weight: 700; color: #fff;">{{ grado.cantidad }}</div>
            <div style="font-size: 0.8rem; color: rgba(255,255,255,0.8); text-align: right;">
              {{ calcularPorcentajeGrados(grado.cantidad) }}%
              <br>
              <span style="font-size: 0.7rem;">del nivel</span>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="conteoGrados.length > 0" style="margin-top: 1rem; text-align: center; font-size: 0.9rem; color: rgba(255,255,255,0.7);">
        💡 Haz clic en un grado para filtrar la tabla
      </div>
    </div>

    <!-- Modal Agregar -->
    <div v-if="showModalAgregar" class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Agregar Alumno</h3>
          <button class="close-btn" @click="cerrarModalAgregar">&times;</button>
        </div>
        <label>Nombre
          <input v-model="alumnoNuevo.nombre" @input="alumnoNuevo.nombre = removerTildes($event.target.value)" style="text-transform: uppercase;" />
        </label>
        <label>Nivel académico
          <select v-model="alumnoNuevo.idnivelacademico" @change="cargarGradosNuevo">
            <option value="">Selecciona un nivel</option>
            <option v-for="nivel in niveles" :key="nivel.id" :value="nivel.id">{{ nivel.nivel }}</option>
          </select>
        </label>
        <label>Grado
          <select v-model="alumnoNuevo.idGrado" @change="cargarTalleresGrupos">
            <option value="">Selecciona un grado</option>
            <option v-for="grado in gradosNuevo" :key="grado.id" :value="grado.id">{{ grado.grado }}</option>
          </select>
        </label>
        <label>Nombre Tutor
          <input v-model="alumnoNuevo.nombreTutor" @input="alumnoNuevo.nombreTutor = removerTildes($event.target.value)" style="text-transform: uppercase;" />
        </label>
        <label>Teléfono Tutor
          <input v-model="alumnoNuevo.telefonoTutor" @input="alumnoNuevo.telefonoTutor = $event.target.value.toUpperCase()" style="text-transform: uppercase;" />
        </label>
        <label>Nombre Tutor 2
          <input v-model="alumnoNuevo.nombreTutor2" @input="alumnoNuevo.nombreTutor2 = removerTildes($event.target.value)" style="text-transform: uppercase;" />
        </label>
        <label>Teléfono Tutor 2
          <input v-model="alumnoNuevo.telefonoTutor2" @input="alumnoNuevo.telefonoTutor2 = $event.target.value.toUpperCase()" style="text-transform: uppercase;" />
        </label>
        <div style="margin-top:1rem;">
          <strong>Selecciona talleres y horarios:</strong>
          <div v-if="talleresGrupos.length === 0" style="color:#888;">Selecciona un grado para ver los talleres disponibles.</div>
          <div v-for="taller in talleresGrupos" :key="taller.id" style="margin-bottom:1.5rem; border:1px solid #ddd; border-radius:8px; padding:1rem;">
            <div style="font-weight:600; color:#007bff; margin-bottom:1rem; font-size:1.1rem;">
              {{ taller.descripcion }}
              <span style="font-size:0.85rem; color:#666; font-weight:normal;">
                ({{ contarHorariosSeleccionados(taller.id) }} horarios seleccionados)
              </span>
            </div>
            
            <div v-for="grupo in taller.grupos" :key="grupo.idGrupo" style="margin-bottom:1rem; border:1px solid #e9ecef; border-radius:6px; padding:0.8rem;">
              <div style="font-weight:600; margin-bottom:0.5rem;">
                Grupo (Cupo Disponible: {{ grupo.cupoDisponible }})
              </div>
              
              <!-- Días uno al lado del otro (horizontal) -->
              <div style="display:flex; gap:0.3rem; flex-wrap:wrap;">
                <div v-for="(horariosPorDia, dia) in agruparHorariosPorDia(grupo.horariosDias)" :key="dia" 
                     style="flex:1; min-width:110px; border:1px solid #e9ecef; border-radius:4px; overflow:hidden;">
                  <!-- Encabezado del día -->
                  <div style="background:#f8f9fa; padding:0.3rem 0.4rem; font-weight:600; color:#495057; border-bottom:1px solid #e9ecef; font-size:0.8rem; text-align:center;">
                    {{ dia }}
                  </div>
                  <!-- Horarios disponibles para este día -->
                  <div style="padding:0.2rem;">
                    <label v-for="horarioDia in horariosPorDia" :key="horarioDia.id" 
                           style="display:table; width:100%; border:1px solid #ddd; border-radius:2px; padding:3px; margin-bottom:2px; cursor:pointer;">
                      <input 
                        type="checkbox" 
                        :value="horarioDia.id"
                        :checked="estaHorarioDiaSeleccionado(horarioDia.id)"
                        :disabled="!puedeSeleccionarHorario(taller.id, horarioDia.id)"
                        @change="toggleHorarioDia(taller.id, horarioDia.id, $event)"
                        style="display:table-cell; width:15px; vertical-align:top; margin:0; padding:0;" 
                      />
                      <span style="display:table-cell; vertical-align:top; padding-left:3px; font-size:0.7rem;">
                        <div style="font-weight:600; color:#333; line-height:1;">{{ horarioDia.horaInicio }}-{{ horarioDia.horaFinal }}</div>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-buttons">
          <button class="btn-primary" @click="guardarNuevo">Agregar</button>
          <button class="btn-secondary" @click="cerrarModalAgregar">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal Editar -->
    <div v-if="showModalEditar" class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Editar Alumno</h3>
          <button class="close-btn" @click="cerrarModalEditar">&times;</button>
        </div>
        <label>Nombre
          <input v-model="alumnoEditar.nombre" @input="alumnoEditar.nombre = removerTildes($event.target.value)" style="text-transform: uppercase;" />
        </label>
        <label>Nivel académico
          <select v-model="alumnoEditar.idnivelacademico" @change="cargarGradosEditar">
            <option value="">Selecciona un nivel</option>
            <option v-for="nivel in niveles" :key="nivel.id" :value="nivel.id">{{ nivel.nivel }}</option>
          </select>
        </label>
        <label>Grado
          <select v-model="alumnoEditar.idgrado" @change="cargarTalleresGruposEditar">
            <option value="">Selecciona un grado</option>
            <option v-for="grado in gradosEditar" :key="grado.id" :value="grado.id">{{ grado.grado }}</option>
          </select>
        </label>
        <label>Nombre Tutor
          <input v-model="alumnoEditar.nombreTutor" @input="alumnoEditar.nombreTutor = removerTildes($event.target.value)" style="text-transform: uppercase;" />
        </label>
        <label>Teléfono Tutor
          <input v-model="alumnoEditar.telefonoTutor" @input="alumnoEditar.telefonoTutor = $event.target.value.toUpperCase()" style="text-transform: uppercase;" />
        </label>
        <label>Nombre Tutor 2
          <input v-model="alumnoEditar.nombreTutor2" @input="alumnoEditar.nombreTutor2 = removerTildes($event.target.value)" style="text-transform: uppercase;" />
        </label>
        <label>Teléfono Tutor 2
          <input v-model="alumnoEditar.telefonoTutor2" @input="alumnoEditar.telefonoTutor2 = $event.target.value.toUpperCase()" style="text-transform: uppercase;" />
        </label>
        <div style="margin-top:1rem;">
          <strong>Selecciona talleres y horarios:</strong>
          <div v-if="talleresGruposEditar.length === 0" style="color:#888;">Selecciona un grado para ver los talleres disponibles.</div>
          <div v-for="taller in talleresGruposEditar" :key="taller.id" style="margin-bottom:1.5rem; border:1px solid #ddd; border-radius:8px; padding:1rem;">
            <div style="font-weight:600; color:#007bff; margin-bottom:1rem; font-size:1.1rem;">
              {{ taller.descripcion }}
              <span style="font-size:0.85rem; color:#666; font-weight:normal;">
                ({{ contarHorariosSeleccionadosEditar(taller.id) }} horarios seleccionados)
              </span>
            </div>
            
            <div v-for="grupo in taller.grupos" :key="grupo.idGrupo" style="margin-bottom:1rem; border:1px solid #e9ecef; border-radius:6px; padding:0.8rem;">
              <div style="font-weight:600; margin-bottom:0.5rem;">
                Grupo (Cupo Disponible: {{ grupo.cupoDisponible }})
              </div>
              
              <!-- Días uno al lado del otro (horizontal) para editar -->
              <div style="display:flex; gap:0.3rem; flex-wrap:wrap;">
                <div v-for="(horariosPorDia, dia) in agruparHorariosPorDia(grupo.horariosDias)" :key="dia" 
                     style="flex:1; min-width:110px; border:1px solid #e9ecef; border-radius:4px; overflow:hidden;">
                  <!-- Encabezado del día -->
                  <div style="background:#f8f9fa; padding:0.3rem 0.4rem; font-weight:600; color:#495057; border-bottom:1px solid #e9ecef; font-size:0.8rem; text-align:center;">
                    {{ dia }}
                  </div>
                  <!-- Horarios disponibles para este día -->
                  <div style="padding:0.2rem;">
                    <label v-for="horarioDia in horariosPorDia" :key="horarioDia.id" 
                           style="display:table; width:100%; border:1px solid #ddd; border-radius:2px; padding:3px; margin-bottom:2px; cursor:pointer;">
                      <input 
                        type="checkbox" 
                        :value="horarioDia.id"
                        :checked="estaHorarioDiaSeleccionadoEditar(horarioDia.id)"
                        :disabled="!puedeSeleccionarHorarioEditar(taller.id, horarioDia.id)"
                        @change="toggleHorarioDiaEditar(taller.id, horarioDia.id, $event)"
                        style="display:table-cell; width:15px; vertical-align:top; margin:0; padding:0;" 
                      />
                      <span style="display:table-cell; vertical-align:top; padding-left:3px; font-size:0.7rem;">
                        <div style="font-weight:600; color:#333; line-height:1;">{{ horarioDia.horaInicio }}-{{ horarioDia.horaFinal }}</div>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-buttons">
          <button class="btn-primary" @click="guardarEdicion">Guardar</button>
          <button class="btn-secondary" @click="cerrarModalEditar">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal Detalles -->
    <div v-if="showModalDetalles" class="modal">
      <div class="modal-content detalles-modal">
        <div class="no-print" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem; border-bottom: 2px solid #007bff; padding-bottom: 1rem;">
          <h3 style="margin: 0; color: #007bff; font-size: 1.5rem;">📋 Detalles del Alumno</h3>
          <button @click="imprimirDetalles" class="btn-imprimir">
            🖨️ Imprimir
          </button>
        </div>
        
        <div id="detallesParaImprimir" class="detalle-contenido">
          <!-- Encabezado para impresión -->
          <div class="print-header">
            <div class="institucion-info">
              <h1>DEPORTIVO PATRIA</h1>
              <h2>FICHA DE ALUMNO</h2>
              <div class="fecha-impresion">Fecha de impresión: {{ fechaActual }}</div>
            </div>
          </div>

          <!-- Información básica del alumno -->
          <div class="info-alumno">
            <div class="seccion-info">
              <h4 class="titulo-seccion">👤 INFORMACIÓN PERSONAL</h4>
              <div class="datos-grid">
                <div class="dato-item">
                  <span class="label">Nombre Completo:</span>
                  <span class="valor">{{ alumnoDetalles.nombre }}</span>
                </div>
                <div class="dato-item">
                  <span class="label">Nivel Académico:</span>
                  <span class="valor">{{ alumnoDetalles.nivelAcademico }}</span>
                </div>
                <div class="dato-item">
                  <span class="label">Grado:</span>
                  <span class="valor">{{ alumnoDetalles.grado }}</span>
                </div>
              </div>
            </div>

            <div class="seccion-info">
              <h4 class="titulo-seccion">📞 INFORMACIÓN DE TUTOR</h4>
              <div class="datos-grid">
                <div class="dato-item">
                  <span class="label">Tutor Principal:</span>
                  <span class="valor">{{ alumnoDetalles.nombreTutor }}</span>
                </div>
                <div class="dato-item">
                  <span class="label">Teléfono:</span>
                  <span class="valor">{{ alumnoDetalles.telefonoTutor }}</span>
                </div>
                <div v-if="alumnoDetalles.nombreTutor2" class="dato-item">
                  <span class="label">Tutor Secundario:</span>
                  <span class="valor">{{ alumnoDetalles.nombreTutor2 }}</span>
                </div>
                <div v-if="alumnoDetalles.telefonoTutor2" class="dato-item">
                  <span class="label">Teléfono 2:</span>
                  <span class="valor">{{ alumnoDetalles.telefonoTutor2 }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Horarios de talleres -->
          <div v-if="alumnoDetalles.horarios && alumnoDetalles.horarios.length > 0" class="seccion-horarios">
            <h4 class="titulo-seccion">🏃‍♂️ TALLERES Y HORARIOS</h4>
          
            
            <!-- Tabla consolidada de horarios -->
            <div class="horarios-consolidados">
              <table class="tabla-horarios-consolidada">
                <thead>
                  <tr>
                    <th style="width: 200px;">TALLER</th>
                    <th v-for="dia in ['Lunes', 'Martes', 'Miércoles', 'Jueves']" :key="dia">
                      {{ dia }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="taller in alumnoDetalles.horarios" :key="taller.idTaller || taller.idGrupo">
                    <td class="nombre-taller">
                      {{ taller.taller || taller.descripcionTaller || taller.descripcion || 'Taller sin nombre' }}
                    </td>
                    <td v-for="dia in ['Lunes', 'Martes', 'Miércoles', 'Jueves']" :key="dia" class="celda-horario">
                      <div v-if="obtenerHorariosPorDia(taller.horariosDias, dia).length > 0" class="horarios-dia">
                        <div v-for="horario in obtenerHorariosPorDia(taller.horariosDias, dia)" :key="horario.id" class="horario-item">
                          {{ horario.horaInicio }} - {{ horario.horaFinal }}
                        </div>
                      </div>
                      <div v-else class="sin-horario">-</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else class="sin-talleres">
            <p>📝 Este alumno no tiene talleres asignados.</p>
          </div>
        </div>

        <div class="no-print modal-actions">
          <button @click="cerrarModalDetalles" class="btn-cerrar">
            ❌ Cerrar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Lista de Asistencia por Nivel y Grado -->
    <div v-if="showModalListaAsistencia" class="modal">
      <div class="modal-content lista-asistencia-modal">
        <div class="modal-header">
          <h3>📋 Lista de Asistencia - {{ nivelGradoSeleccionado }}</h3>
          <button @click="cerrarModalListaAsistencia" class="btn-close">❌</button>
        </div>
        
        <div class="resumen-info">
          <div class="info-card">
            <div class="info-label">Total de Alumnos:</div>
            <div class="info-value">{{ alumnosListaAsistencia.length }}</div>
          </div>
          <div class="info-card">
            <div class="info-label">Nivel Académico:</div>
            <div class="info-value">{{ obtenerNombreNivel(filtros.idnivelacademico) }}</div>
          </div>
          <div class="info-card">
            <div class="info-label">Grado:</div>
            <div class="info-value">{{ obtenerNombreGrado(filtros.idgrado) }}</div>
          </div>
        </div>

        <div class="acciones-modal">
          <button @click="descargarExcelNivelGrado" class="btn-descargar">
            📊 Descargar Excel
          </button>
          <button @click="generarListaAsistenciaCompleta" class="btn-lista-completa">
            📋 Lista Completa de Talleres
          </button>
        </div>

        <div class="tabla-container">
          <table class="tabla-alumnos-modal">
            <thead>
              <tr>
                <th>#</th>
                <th>Alumno</th>
                <th>Nivel y Grado Académico</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(alumno, index) in alumnosListaAsistencia" :key="alumno.id">
                <td class="numero-alumno">{{ index + 1 }}</td>
                <td class="nombre-alumno">{{ alumno.nombre }}</td>
                <td class="nivel-grado-academico">
                  <span class="nivel-grado-badge">
                    {{ obtenerNivelGradoAlumno(alumno) }}
                  </span>
                </td>
              </tr>
              <tr v-if="alumnosListaAsistencia.length === 0">
                <td colspan="3" class="sin-datos">No hay alumnos en este nivel y grado</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '../restapi.js';

export default {
  name: 'AlumnosView',
  data() {
    // Leer permisos de localStorage
    let permisosAlumnos = [];
    try {
      const permisos = JSON.parse(localStorage.getItem('permisos') || '{}');
      permisosAlumnos = permisos['/alumnos'] || [];
    } catch (e) {}
    
    return {
      alumnos: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filtros: {
        nombre: '',
        idnivelacademico: '',
        idgrado: '',
        idtaller: ''
      },
      niveles: [],
      grados: [],
      talleres: [],
      showModalAgregar: false,
      showModalEditar: false,
      showModalDetalles: false,
      showModalListaAsistencia: false,
      alumnoDetalles: {},
      alumnoNuevo: {
        nombre: '',
        idnivelacademico: '',
        idGrado: '',
        talleresHorarios: [],
        nombreTutor: '',
        telefonoTutor: '',
        nombreTutor2: '',
        telefonoTutor2: ''
      },
      alumnoEditar: null,
      gradosNuevo: [],
      gradosEditar: [],
      talleresGrupos: [],
      talleresGruposEditar: [],
      // Nuevas propiedades para selección de horarios individuales
      horariosSeleccionados: [], // Array de IDs como "15-1-1"
      horariosSeleccionadosEditar: [], // Array de IDs como "15-1-1" para editar
      // Modal lista de asistencia
      alumnosListaAsistencia: [],
      nivelGradoSeleccionado: '',
      permisosAlumnos,
      // Card de conteo por niveles
      conteoNiveles: [],
      cargandoConteo: false,
      // Card de conteo por grados
      conteoGrados: [],
      nivelSeleccionado: null,
      mostrarConteoGrados: false,
      cargandoConteoGrados: false
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
    puedeModificarAlumno() {
      return this.permisosAlumnos.some(p => p.Descripcion === 'Modificar Alumnos');
    },
    puedeEliminarAlumno() {
      return this.permisosAlumnos.some(p => p.Descripcion === 'Eliminar Alumnos');
    },
    fechaActual() {
      return new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  },
  watch: {
    // Detectar cambios en los filtros para actualizar el card
    'filtros.idnivelacademico': {
      handler() {
        // Actualizar conteo cuando cambie el filtro de nivel
        setTimeout(() => this.cargarConteoNiveles(), 300);
      },
      immediate: false
    },
    'filtros.idgrado': {
      handler() {
        // Actualizar conteo cuando cambie el filtro de grado
        setTimeout(() => this.cargarConteoNiveles(), 300);
      },
      immediate: false
    },
    'filtros.idtaller': {
      handler() {
        // Actualizar conteo cuando cambie el filtro de taller
        setTimeout(() => this.cargarConteoNiveles(), 300);
      },
      immediate: false
    },
    // Detectar cambios en la búsqueda por nombre
    'filtros.nombre': {
      handler() {
        // Actualizar conteo cuando cambie la búsqueda
        setTimeout(() => this.cargarConteoNiveles(), 500);
      },
      immediate: false
    }
  },
  watch: {
    // Detectar cambios en los filtros para actualizar el card
    'filtros.idnivelacademico': {
      handler() {
        // Actualizar conteo cuando cambie el filtro de nivel
        setTimeout(() => this.cargarConteoNiveles(), 300);
      },
      immediate: false
    },
    'filtros.idgrado': {
      handler() {
        // Actualizar conteo cuando cambie el filtro de grado
        setTimeout(() => this.cargarConteoNiveles(), 300);
      },
      immediate: false
    },
    'filtros.idtaller': {
      handler() {
        // Actualizar conteo cuando cambie el filtro de taller
        setTimeout(() => this.cargarConteoNiveles(), 300);
      },
      immediate: false
    },
    // Detectar cambios en la búsqueda por nombre
    'filtros.nombre': {
      handler() {
        // Actualizar conteo cuando cambie la búsqueda
        setTimeout(() => this.cargarConteoNiveles(), 500);
      },
      immediate: false
    }
  },
  async mounted() {
    // Cargar datos iniciales
    await this.fetchNiveles();
    await this.fetchTalleres();
    await this.buscarAlumnos();
    // Cargar conteo de niveles automáticamente
    await this.cargarConteoNiveles();
    
    // Detectar cuando el usuario regresa a la pantalla
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    
    // Detectar cambios de foco en la ventana
    window.addEventListener('focus', this.handleWindowFocus);
  },
  beforeUnmount() {
    // Limpiar event listeners
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
  },
  methods: {
    // Función para remover tildes y caracteres especiales
    removerTildes(texto) {
      if (!texto) return '';
      return texto
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remueve los diacríticos (tildes)
        .replace(/[^A-Z0-9\s]/gi, '') // Solo permite letras, números y espacios
        .toUpperCase();
    },
    
    async fetchNiveles() {
      const response = await apiFetch('/nivelyGrados/ObtenerListaNivelesAcademicos', {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      this.niveles = await response.json();
    },
    async fetchTalleres() {
      const response = await apiFetch('/talleres/ObtenerListaTalleres', {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      this.talleres = await response.json();
    },
    async cargarGrados() {
      if (!this.filtros.idnivelacademico) {
        this.grados = [];
        return;
      }
      const response = await apiFetch(`/nivelyGrados/ObtenerListaGrados?idnivelacademico=${this.filtros.idnivelacademico}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      this.grados = await response.json();
    },
    async buscarAlumnos() {
      const params = `?nombre=${encodeURIComponent(this.filtros.nombre||'')}&idnivelacademico=${this.filtros.idnivelacademico||''}&idgrado=${this.filtros.idgrado||''}&idtaller=${this.filtros.idtaller||''}&page=${this.page}&pageSize=${this.pageSize}`;
      const response = await apiFetch(`/alumnos/ObtenerAlumnosPaginado${params}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await response.json();
      this.alumnos = data.alumnos || [];
      this.total = data.total || 0;
      
      // Actualizar conteo después de buscar (con delay para evitar llamadas excesivas)
      setTimeout(() => this.cargarConteoNiveles(), 100);
    },
    async aplicarFiltros() {
      this.page = 1; // Resetear a la primera página cuando se aplican filtros
      await this.buscarAlumnos();
      // Actualizar conteo después de aplicar filtros
      setTimeout(() => this.cargarConteoNiveles(), 300);
    },
    cambiarPagina(nuevaPagina) {
      this.page = nuevaPagina;
      this.buscarAlumnos();
      // Actualizar conteo después de cambiar página
      setTimeout(() => this.cargarConteoNiveles(), 200);
    },
    abrirModalAgregar() {
      this.alumnoNuevo = {
        nombre: '',
        idnivelacademico: '',
        idGrado: '',
        talleresHorarios: [],
        nombreTutor: '',
        telefonoTutor: '',
        nombreTutor2: '',
        telefonoTutor2: ''
      };
      this.gradosNuevo = [];
      this.talleresGrupos = [];
      this.horariosSeleccionados = []; // Limpiar horarios seleccionados
      this.showModalAgregar = true;
    },
    cerrarModalAgregar() {
      this.showModalAgregar = false;
      this.horariosSeleccionados = []; // Limpiar horarios seleccionados
    },
    async cargarGradosNuevo() {
      if (!this.alumnoNuevo.idnivelacademico) {
        this.gradosNuevo = [];
        return;
      }
      const response = await apiFetch(`/nivelyGrados/ObtenerListaGrados?idnivelacademico=${this.alumnoNuevo.idnivelacademico}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      this.gradosNuevo = await response.json();
    },
    async cargarTalleresGrupos() {
      if (!this.alumnoNuevo.idGrado) {
        this.talleresGrupos = [];
        return;
      }
      const response = await apiFetch(`/talleres/ObtenerListaTalleresPorGrado?idgrado=${this.alumnoNuevo.idGrado}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      this.talleresGrupos = await response.json();
    },

    async cargarTalleresGruposEditar() {
      if (!this.alumnoEditar || !this.alumnoEditar.idgrado) {
        this.talleresGruposEditar = [];
        return;
      }
      const response = await apiFetch(`/talleres/ObtenerListaTalleresPorGrado?idgrado=${this.alumnoEditar.idgrado}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      this.talleresGruposEditar = await response.json();
    },

    // Método para agrupar horarios por día
    agruparHorariosPorDia(horariosDias) {
      if (!horariosDias || !Array.isArray(horariosDias)) {
        return {};
      }
      
      const grupos = {};
      horariosDias.forEach(horario => {
        // Verificar diferentes posibles nombres de la propiedad día
        const dia = horario.dia || horario.Dia || horario.day;
        if (dia) {
          const diaUpper = dia.toString().toUpperCase();
          if (!grupos[diaUpper]) {
            grupos[diaUpper] = [];
          }
          grupos[diaUpper].push(horario);
        }
      });
      
      // Ordenar horarios dentro de cada día por hora de inicio
      Object.keys(grupos).forEach(dia => {
        grupos[dia].sort((a, b) => {
          const horaA = a.horaInicio || a.HoraInicio || '';
          const horaB = b.horaInicio || b.HoraInicio || '';
          return horaA.localeCompare(horaB);
        });
      });
      
      // Crear un objeto ordenado por días de la semana
      const ordenDias = ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES'];
      const gruposOrdenados = {};
      
      ordenDias.forEach(dia => {
        if (grupos[dia]) {
          gruposOrdenados[dia] = grupos[dia];
        }
      });
      
      return gruposOrdenados;
    },

    // Métodos para manejar selección de horarios individuales
    toggleHorarioDia(tallerId, horarioDiaId, event) {
      if (event.target.checked) {
        this.horariosSeleccionados.push(horarioDiaId);
      } else {
        const index = this.horariosSeleccionados.indexOf(horarioDiaId);
        if (index > -1) {
          this.horariosSeleccionados.splice(index, 1);
        }
      }
    },

    toggleHorarioDiaEditar(tallerId, horarioDiaId, event) {
      if (event.target.checked) {
        this.horariosSeleccionadosEditar.push(horarioDiaId);
      } else {
        const index = this.horariosSeleccionadosEditar.indexOf(horarioDiaId);
        if (index > -1) {
          this.horariosSeleccionadosEditar.splice(index, 1);
        }
      }
    },

    contarHorariosSeleccionados(tallerId) {
      return this.horariosSeleccionados.filter(id => {
        // Buscar el taller al que pertenece este horario
        for (const taller of this.talleresGrupos) {
          if (taller.id === tallerId) {
            for (const grupo of taller.grupos) {
              if (grupo.horariosDias.some(h => h.id === id)) {
                return true;
              }
            }
          }
        }
        return false;
      }).length;
    },

    contarHorariosSeleccionadosEditar(tallerId) {
      return this.horariosSeleccionadosEditar.filter(id => {
        // Buscar el taller al que pertenece este horario
        for (const taller of this.talleresGruposEditar) {
          if (taller.id === tallerId) {
            for (const grupo of taller.grupos) {
              if (grupo.horariosDias.some(h => h.id === id)) {
                return true;
              }
            }
          }
        }
        return false;
      }).length;
    },

    estaHorarioDiaSeleccionado(horarioDiaId) {
      return this.horariosSeleccionados.includes(horarioDiaId);
    },

    estaHorarioDiaSeleccionadoEditar(horarioDiaId) {
      return this.horariosSeleccionadosEditar.includes(horarioDiaId);
    },

    puedeSeleccionarHorario(tallerId, horarioDiaId) {
      // Siempre puede seleccionar o deseleccionar
      return true;
    },

    puedeSeleccionarHorarioEditar(tallerId, horarioDiaId) {
      // Siempre puede seleccionar o deseleccionar
      return true;
    },

    async guardarNuevo() {
      try {
        const response = await apiFetch('/alumnos/AgregarAlumno', {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            nombre: this.alumnoNuevo.nombre,
            idGrado: this.alumnoNuevo.idGrado,
            talleresHorarios: this.horariosSeleccionados, // Enviar array de IDs como "15-1-1"
            idnivelacademico: this.alumnoNuevo.idnivelacademico,
            nombreTutor: this.alumnoNuevo.nombreTutor,
            telefonoTutor: this.alumnoNuevo.telefonoTutor,
            nombreTutor2: this.alumnoNuevo.nombreTutor2,
            telefonoTutor2: this.alumnoNuevo.telefonoTutor2
          })
        });
        if (!response.ok) {
          // Leer el mensaje de la respuesta de la API
          let msg = 'Error al agregar alumno';
          try {
            const data = await response.json();
            if (data && data.message) msg = data.message;
          } catch (e) {}
          if (this.$toast) this.$toast.error(msg);
          return;
        }
        
        const data = await response.json();
        this.cerrarModalAgregar();
        this.buscarAlumnos();
        // Actualizar conteo de niveles después de agregar
        await this.cargarConteoNiveles();
        if (this.$toast) this.$toast.success(data.message || 'Alumno agregado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error(err.message || 'Error al agregar alumno');
      }
    },
    abrirModalEditar(alumno) {
      // Convertir los talleres existentes al nuevo formato de IDs "idGrupo-idHorario-idDia"
      this.horariosSeleccionadosEditar = [];
      if (Array.isArray(alumno.talleres)) {
        alumno.talleres.forEach(taller => {
          if (taller.horariosDias && Array.isArray(taller.horariosDias)) {
            taller.horariosDias.forEach(horario => {
              // Crear el ID en formato "idGrupo-idHorario-idDia"
              const horarioId = `${taller.idGrupo}-${horario.idHorario}-${horario.idDia}`;
              this.horariosSeleccionadosEditar.push(horarioId);
            });
          }
        });
      }

      this.alumnoEditar = {
        id: alumno.id,
        nombre: alumno.nombre,
        idnivelacademico: alumno.idnivelacademico,
        idgrado: alumno.idgrado,
        nombreTutor: alumno.nombretutor,
        telefonoTutor: alumno.telefonotutor,
        nombreTutor2: alumno.nombretutor2,
        telefonoTutor2: alumno.telefonotutor2
      };
      this.gradosEditar = [];
      this.talleresGruposEditar = [];
      this.showModalEditar = true;
      this.cargarGradosEditar();
      this.cargarTalleresGruposEditar();
    },
    cerrarModalEditar() {
      this.showModalEditar = false;
      this.alumnoEditar = null;
      this.horariosSeleccionadosEditar = []; // Limpiar horarios seleccionados para editar
    },
    async cargarGradosEditar() {
      if (!this.alumnoEditar.idnivelacademico) {
        this.gradosEditar = [];
        this.talleresGruposEditar = [];
        return;
      }
      const response = await apiFetch(`/nivelyGrados/ObtenerListaGrados?idnivelacademico=${this.alumnoEditar.idnivelacademico}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      this.gradosEditar = await response.json();
      // Si ya hay grado seleccionado, recargar talleres/grupos
      if (this.alumnoEditar.idgrado) {
        this.cargarTalleresGruposEditar();
      }
    },
    async guardarEdicion() {
      try {
        const response = await apiFetch(`/alumnos/ModificarAlumno/${this.alumnoEditar.id}`, {
          method: 'PATCH',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            nombre: this.alumnoEditar.nombre,
            idnivelacademico: this.alumnoEditar.idnivelacademico,
            idgrado: this.alumnoEditar.idgrado,
            talleresHorarios: this.horariosSeleccionadosEditar, // Enviar array de IDs como "15-1-1"
            nombreTutor: this.alumnoEditar.nombreTutor,
            telefonoTutor: this.alumnoEditar.telefonoTutor,
            nombreTutor2: this.alumnoEditar.nombreTutor2,
            telefonoTutor2: this.alumnoEditar.telefonoTutor2
          })
        });
        if (!response.ok) throw new Error('Error al editar alumno');
        
        const data = await response.json();
        this.cerrarModalEditar();
        this.buscarAlumnos();
        // Actualizar conteo de niveles después de editar
        await this.cargarConteoNiveles();
        if (this.$toast) this.$toast.success(data.message || 'Alumno editado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error('Error al editar alumno');
      }
    },
    
    // Métodos para manejar la nueva selección de horarios
    obtenerDiasDisponibles(grupo) {
      if (!grupo.horariosDias) return [];
      const dias = new Set();
      grupo.horariosDias.forEach(h => dias.add(h.dia));
      return Array.from(dias);
    },
    
    obtenerHorariosPorDia(grupo, dia) {
      if (!grupo.horariosDias) return [];
      return grupo.horariosDias.filter(h => h.dia === dia);
    },
    
    obtenerHorariosUnicos(grupo) {
      if (!grupo.horariosDias) return [];
      const horariosMap = new Map();
      
      grupo.horariosDias.forEach(h => {
        if (!horariosMap.has(h.idHorario)) {
          horariosMap.set(h.idHorario, {
            idHorario: h.idHorario,
            horaInicio: h.horaInicio,
            horaFinal: h.horaFinal
          });
        }
      });
      
      return Array.from(horariosMap.values());
    },
    
    obtenerDiasDelHorario(grupo, idHorario) {
      if (!grupo.horariosDias) return [];
      return grupo.horariosDias
        .filter(h => h.idHorario === idHorario)
        .map(h => h.dia);
    },
    
    actualizarSeleccionHorarioCompleto(event, idGrupo, idHorario, grupo) {
      if (event.target.checked) {
        // Agregar todas las combinaciones de este horario con todos sus días
        const diasDelHorario = grupo.horariosDias
          .filter(h => h.idHorario === idHorario)
          .map(h => ({ idGrupo: idGrupo, idHorario: idHorario, idDia: h.idDia }));
        
        this.alumnoNuevo.talleresHorarios.push(...diasDelHorario);
      } else {
        // Remover todas las combinaciones de este horario
        this.alumnoNuevo.talleresHorarios = this.alumnoNuevo.talleresHorarios.filter(th => 
          !(th.idGrupo === idGrupo && th.idHorario === idHorario)
        );
      }
    },
    
    actualizarSeleccionHorarioCompletoEditar(event, idGrupo, idHorario, grupo) {
      if (event.target.checked) {
        // Agregar todas las combinaciones de este horario con todos sus días
        const diasDelHorario = grupo.horariosDias
          .filter(h => h.idHorario === idHorario)
          .map(h => ({ idGrupo: idGrupo, idHorario: idHorario, idDia: h.idDia }));
        
        this.alumnoEditar.talleresHorarios.push(...diasDelHorario);
      } else {
        // Remover todas las combinaciones de este horario
        this.alumnoEditar.talleresHorarios = this.alumnoEditar.talleresHorarios.filter(th => 
          !(th.idGrupo === idGrupo && th.idHorario === idHorario)
        );
      }
    },
    
    estaHorarioSeleccionadoEditar(idGrupo, idHorario) {
      if (!this.alumnoEditar || !this.alumnoEditar.talleresHorarios) return false;
      return this.alumnoEditar.talleresHorarios.some(th => 
        th.idGrupo === idGrupo && th.idHorario === idHorario
      );
    },
    async eliminarAlumno(id) {
      if (confirm('¿Seguro que deseas eliminar este alumno?')) {
        try {
          const response = await apiFetch(`/alumnos/EliminarAlumno/${id}`, {
            method: 'DELETE',
            headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          if (!response.ok) throw new Error('Error al eliminar alumno');
          
          const data = await response.json();
          this.buscarAlumnos();
          // Actualizar conteo de niveles después de eliminar
          await this.cargarConteoNiveles();
          if (this.$toast) this.$toast.success(data.message || 'Alumno eliminado correctamente');
        } catch (err) {
          if (this.$toast) this.$toast.error('Error al eliminar alumno');
        }
      }
    },
    
    // Nuevo método para manejar el botón de lista de asistencia
    async manejarListaAsistencia() {
      // Si tiene nivel Y grado seleccionados, abrir modal
      if (this.filtros.idnivelacademico && this.filtros.idgrado) {
        await this.abrirModalListaAsistencia();
      } else {
        // Si no, usar el comportamiento original
        await this.generarListaAsistencia();
      }
    },

    async abrirModalListaAsistencia() {
      try {
        // Obtener el nombre del nivel y grado para el título
        const nivel = this.niveles.find(n => n.id == this.filtros.idnivelacademico);
        const grado = this.grados.find(g => g.id == this.filtros.idgrado);
        
        this.nivelGradoSeleccionado = `${nivel ? nivel.nivel : ''} - ${grado ? grado.grado : ''}`;
        
        // Obtener alumnos del nivel y grado seleccionado
        this.alumnosListaAsistencia = await this.obtenerAlumnosPorNivelYGrado(
          this.filtros.idnivelacademico, 
          this.filtros.idgrado
        );
        
        // Ordenar alfabéticamente por nombre (A-Z)
        this.alumnosListaAsistencia.sort((a, b) => {
          return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' });
        });
        
        this.showModalListaAsistencia = true;
        
      } catch (error) {
        console.error('Error al cargar lista de asistencia:', error);
        if (this.$toast) this.$toast.error('Error al cargar la lista de asistencia');
      }
    },

    cerrarModalListaAsistencia() {
      this.showModalListaAsistencia = false;
      this.alumnosListaAsistencia = [];
      this.nivelGradoSeleccionado = '';
    },

    obtenerNombreNivel(idNivel) {
      const nivel = this.niveles.find(n => n.id == idNivel);
      return nivel ? nivel.nivel : '';
    },

    obtenerNombreGrado(idGrado) {
      const grado = this.grados.find(g => g.id == idGrado);
      return grado ? grado.grado : '';
    },

    async descargarExcelNivelGrado() {
      try {
        const ExcelJS = await import('exceljs');
        const workbook = new ExcelJS.Workbook();
        
        // Obtener nombres para el título
        const nombreNivel = this.obtenerNombreNivel(this.filtros.idnivelacademico);
        const nombreGrado = this.obtenerNombreGrado(this.filtros.idgrado);
        const titulo = `${nombreNivel} - ${nombreGrado}`;
        
        const worksheet = workbook.addWorksheet('Lista de Asistencia');
        worksheet.pageSetup.orientation = 'landscape';

        // Generar fechas del mes actual
        const fechasDelMes = this.generarFechasDelMes(['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES']);
        
        const totalColumnas = 3 + fechasDelMes.length; // # + ALUMNO + NIVEL Y GRADO + fechas
        const ultimaColumna = String.fromCharCode(64 + totalColumnas); // A=65, B=66, etc.

        // TÍTULO: Nivel y Grado (centrado en toda la fila A1:E3) - EXACTO AL DE HORARIOS
        worksheet.mergeCells('A1:E3');
        worksheet.getCell('A1').value = titulo;
        worksheet.getCell('A1').style = {
          font: { bold: true, size: 22, color: { argb: 'FFFFFFFF' } },
          alignment: { horizontal: 'center', vertical: 'middle' },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } }
        };

        // LOGO: Cargar e insertar logo en posición ABSOLUTA (libre, sin depender de columnas) - EXACTO AL DE HORARIOS
        try {
          fetch('/images/deportivopatria.jpg')
            .then(responseImg => {
              if (responseImg.ok) {
                return responseImg.arrayBuffer();
              }
              throw new Error('No se pudo cargar la imagen');
            })
            .then(imageBuffer => {
              const imageId = workbook.addImage({
                buffer: imageBuffer,
                extension: 'jpg',
              });
              // Posición ABSOLUTA - cambia x (derecha) y y (abajo) libremente en píxeles
              worksheet.addImage(imageId, {
                tl: { x: 50, y: 15 }, // x=píxeles desde izquierda, y=píxeles desde arriba
                ext: { width: 80, height: 80 }, // tamaño fijo en píxeles
                editAs: 'absolute'
              });
            })
            .catch(error => {
              console.log('No se pudo cargar el logo:', error);
            });
        } catch (error) {
          console.log('No se pudo cargar el logo:', error);
        }

        // SUBTÍTULO: LISTA DE ASISTENCIA (fila 4) - EXACTO AL DE HORARIOS
        worksheet.mergeCells('A4:E4');
        worksheet.getCell('A4').value = 'LISTA DE ASISTENCIA';
        worksheet.getCell('A4').style = {
          font: { bold: true, size: 14, color: { argb: 'FFFFFFFF' } },
          alignment: { horizontal: 'center', vertical: 'middle' },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } }
        };

        // Ajustar altura de las filas de títulos - EXACTO AL DE HORARIOS
        worksheet.getRow(1).height = 30;
        worksheet.getRow(2).height = 30;
        worksheet.getRow(3).height = 30;
        worksheet.getRow(4).height = 22;

        // Encabezados (fila 5) - EXACTO AL DE HORARIOS
        worksheet.getCell('A5').value = '#';
        worksheet.getCell('B5').value = 'ALUMNO';
        worksheet.getCell('C5').value = 'NIVEL Y GRADO';
        worksheet.getCell('D5').value = 'ASISTENCIA';
        
        // Si hay fechas específicas, agregar más columnas
        fechasDelMes.forEach((fecha, index) => {
          const col = String.fromCharCode(68 + index); // D, E, F, etc.
          worksheet.getCell(`${col}5`).value = fecha;
        });

        // Formato encabezados - DINÁMICO SEGÚN FECHAS
        const columnasEncabezados = [];
        
        // Generar todas las columnas dinámicamente (usar totalColumnas ya declarado anteriormente)
        for (let i = 0; i < totalColumnas; i++) {
          columnasEncabezados.push(String.fromCharCode(65 + i)); // A, B, C, D, E, F...
        }

        columnasEncabezados.forEach(col => {
          worksheet.getCell(`${col}5`).style = {
            font: { bold: true, color: { argb: 'FFFFFFFF' } },
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } },
            alignment: { horizontal: 'center', vertical: 'middle' }
          };
        });

        // Ajustar anchos de columnas automáticamente al contenido
        worksheet.columns.forEach(column => {
          let maxLength = 0;
          column.eachCell({ includeEmpty: false }, (cell) => {
            const columnLength = cell.value ? cell.value.toString().length : 0;
            if (columnLength > maxLength) {
              maxLength = columnLength;
            }
          });
          // Establecer ancho mínimo y máximo
          column.width = Math.max(8, Math.min(maxLength + 2, 50));
        });        // Por cada alumno, llenar su asistencia (empezar en fila 6)
        const alumnosOrdenados = [...this.alumnosListaAsistencia].sort((a, b) => {
          return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' });
        });

        let row = 6;
        for (const [index, alumno] of alumnosOrdenados.entries()) {
          const nivelGrado = this.obtenerNivelGradoAlumno(alumno);
          const numeroAscendente = index + 1;
          
          // Llenar datos básicos (sin espacios extra)
          worksheet.getCell(`A${row}`).value = numeroAscendente;
          worksheet.getCell(`B${row}`).value = alumno.nombre.trim();
          worksheet.getCell(`C${row}`).value = nivelGrado.trim();
          
          // Aplicar estilo compacto a las celdas de datos
          worksheet.getCell(`A${row}`).style = {
            alignment: { horizontal: 'center', vertical: 'middle' },
            border: { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} }
          };
          worksheet.getCell(`B${row}`).style = {
            alignment: { horizontal: 'left', vertical: 'middle' },
            border: { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} }
          };
          worksheet.getCell(`C${row}`).style = {
            alignment: { horizontal: 'center', vertical: 'middle' },
            border: { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} }
          };
          
          // Llenar fechas vacías para asistencia
          fechasDelMes.forEach((fecha, fechaIndex) => {
            const col = String.fromCharCode(68 + fechaIndex);
            const cell = worksheet.getCell(`${col}${row}`);
            cell.value = '';
            cell.style = {
              alignment: { horizontal: 'center', vertical: 'middle' },
              border: { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} }
            };
          });
          
          // Ajustar altura de fila más compacta
          worksheet.getRow(row).height = 20;
          row++;
        }

        // Ajustar anchos de columnas automáticamente al contenido
        worksheet.columns.forEach((column, index) => {
          let maxLength = 0;
          column.eachCell({ includeEmpty: false }, (cell) => {
            const columnLength = cell.value ? cell.value.toString().length : 0;
            if (columnLength > maxLength) {
              maxLength = columnLength;
            }
          });
          // Establecer ancho mínimo y máximo para evitar columnas muy estrechas o anchas
          if (index === 0) {
            column.width = Math.max(4, Math.min(maxLength + 1, 8)); // Columna # más estrecha
          } else {
            column.width = Math.max(10, Math.min(maxLength + 2, 40)); // Otras columnas
          }
        });

        // Generar y descargar archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Lista_Asistencia_${titulo.replace(/\s+/g, '_')}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);

        if (this.$toast) this.$toast.success('Lista de alumnos descargada exitosamente');

      } catch (error) {
        console.error('Error al generar Excel:', error);
        if (this.$toast) this.$toast.error('Error al generar el archivo Excel');
      }
    },

    async generarListaAsistenciaCompleta() {
      // Usar el método original para generar lista completa
      await this.generarListaAsistencia();
    },

    async generarListaAsistencia() {
      try {
        const ExcelJS = await import('exceljs');
        
        if (this.filtros.idtaller === '') {
          // Generar Excel con todos los talleres (un libro por taller)
          await this.generarExcelTodosTalleres(ExcelJS);
        } else {
          // Generar Excel para un taller específico
          await this.generarExcelTallerEspecifico(ExcelJS, this.filtros.idtaller);
        }
      } catch (error) {
        console.error('Error al generar lista de asistencia:', error);
        if (this.$toast) this.$toast.error('Error al generar lista de asistencia');
      }
    },

    obtenerNivelGradoAlumno(alumno) {
      // La API ya devuelve los nombres de nivel y grado directamente
      const nombreNivel = alumno.nivel || 'N/A';
      const nombreGrado = alumno.grado || 'N/A';
      
      return `${nombreNivel} - ${nombreGrado}`;
    },

  async obtenerAlumnosPorNivelYGrado(idNivelAcademico = '', idGrado = '') {
    const params = `?nombre=&idnivelacademico=${idNivelAcademico}&idgrado=${idGrado}&idtaller=&page=1&pageSize=5000`;
    const response = await apiFetch(`/alumnos/ObtenerAlumnosPaginado${params}`, {
      headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    const data = await response.json();
    return data.alumnos || [];
  },
      
async generarHorarios() {
  try {
    const ExcelJS = await import('exceljs');
    const workbook = new ExcelJS.Workbook();

    // Obtener todos los grados
    let grados = [];
    if (this.filtros.idgrado === '') {
      const response = await apiFetch(`/nivelyGrados/ObtenerListaGrados?idnivelacademico=${this.filtros.idnivelacademico || ''}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      grados = await response.json();
    } else {
      grados = this.grados.filter(g => g.id == this.filtros.idgrado);
    }

    // Obtener todos los alumnos de una sola vez
    const alumnos = await this.obtenerAlumnosPorNivelYGrado(this.filtros.idnivelacademico || '', '');

    // Agrupar alumnos por grado
    const alumnosPorGrado = {};
    for (const alumno of alumnos) {
      const key = `${alumno.nivel || ''} ${alumno.grado || ''}`.trim();
      if (!alumnosPorGrado[key]) alumnosPorGrado[key] = [];
      alumnosPorGrado[key].push(alumno);
    }

    for (const grado of grados) {
      // Buscar el nivel y grado correcto
      let nivel = grado.nivel;
      let nombreGrado = grado.grado;
      
      // Si el objeto grado no tiene nivel, buscarlo en el primer alumno de ese grado
      if (!nivel) {
        const alumnoEjemplo = alumnos.find(a => a.idgrado == grado.id);
        if (alumnoEjemplo) {
          nivel = alumnoEjemplo.nivel;
          nombreGrado = alumnoEjemplo.grado;
        }
      }
      
      // Buscar alumnos de este grado usando la clave correcta
      const key = `${nivel || ''} ${nombreGrado || ''}`.trim();
      const alumnosGrado = (alumnosPorGrado[key] || []).sort((a, b) => {
        return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' });
      });

      // Crear hoja para el grado, asegurando nombre único
      let baseName = key.substring(0, 31);
      let sheetName = baseName;
      let count = 1;
      while (workbook.getWorksheet(sheetName)) {
        sheetName = `${baseName}_${count}`;
        count++;
      }
      const worksheet = workbook.addWorksheet(sheetName);
      worksheet.pageSetup.orientation = 'landscape';

      // TÍTULO: Nivel y Grado (centrado en toda la fila A1:F3)
      worksheet.mergeCells('A1:F3');
      worksheet.getCell('A1').value = `${nivel || ''} ${nombreGrado || ''}`.trim();
      worksheet.getCell('A1').style = {
        font: { bold: true, size: 22, color: { argb: 'FFFFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'middle' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } }
      };

      // LOGO: Cargar e insertar logo en posición ABSOLUTA (libre, sin depender de columnas)
      try {
        const responseImg = await fetch('/images/deportivopatria.jpg');
          if (responseImg.ok) {
            const imageBuffer = await responseImg.arrayBuffer();
            const imageId = workbook.addImage({
              buffer: imageBuffer,
              extension: 'jpg',
            });
            // Posición ABSOLUTA - cambia x (derecha) y y (abajo) libremente en píxeles
            worksheet.addImage(imageId, {
              tl: { x: 50, y: 15 }, // x=píxeles desde izquierda, y=píxeles desde arriba
              ext: { width: 80, height: 80 }, // tamaño fijo en píxeles
              editAs: 'absolute'
            });
          }
      } catch (error) {
        console.log('No se pudo cargar el logo:', error);
      }

      // SUBTÍTULO: HORARIO DE ALUMNOS EN EXTRACURRICULARES (fila 4)
      worksheet.mergeCells('A4:F4');
      worksheet.getCell('A4').value = 'HORARIO DE ALUMNOS EN EXTRACURRICULARES';
      worksheet.getCell('A4').style = {
        font: { bold: true, size: 14, color: { argb: 'FFFFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'middle' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } }
      };

      // Encabezados (ahora en fila 6) - CON COLUMNA #
      worksheet.getCell('A5').value = '#';
      worksheet.getCell('B5').value = 'ALUMNO';
      worksheet.getCell('C5').value = 'LUNES';
      worksheet.getCell('D5').value = 'MARTES';
      worksheet.getCell('E5').value = 'MIÉRCOLES';
      worksheet.getCell('F5').value = 'JUEVES';

      // Formato encabezados
      ['A', 'B', 'C', 'D', 'E', 'F'].forEach(col => {
        worksheet.getCell(`${col}5`).style = {
          font: { bold: true, color: { argb: 'FFFFFFFF' } },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } },
          alignment: { horizontal: 'center', vertical: 'middle' }
        };
        // Ajustar anchos: # (estrecha), ALUMNO (ancha), días (medianas)
        if (col === 'A') worksheet.getColumn(col).width = 5;  // Columna #
        else if (col === 'B') worksheet.getColumn(col).width = 35; // Columna ALUMNO
        else worksheet.getColumn(col).width = 22; // Columnas de días
      });

      // Ajustar altura de las filas de títulos
      worksheet.getRow(1).height = 30;
      worksheet.getRow(2).height = 30;
      worksheet.getRow(3).height = 30;
      worksheet.getRow(4).height = 22;

      // Por cada alumno, llenar su horario (empezar en fila 6)
      let row = 6;
      for (const [index, alumno] of alumnosGrado.entries()) {
        const numeroAscendente = index + 1;
        worksheet.getCell(`A${row}`).value = numeroAscendente;
        worksheet.getCell(`B${row}`).value = alumno.nombre;

        // Inicializar días
        const dias = { LUNES: '', MARTES: '', MIÉRCOLES: '', JUEVES: '', VIERNES: '' };

        // Recorrer talleres y horarios del alumno
        if (alumno.talleres && Array.isArray(alumno.talleres)) {
          for (const taller of alumno.talleres) {
            if (taller.horariosDias && Array.isArray(taller.horariosDias)) {
              for (const h of taller.horariosDias) {
                let dia = h.Dia ? h.Dia.toUpperCase() : '';
                const separador = dias[dia] ? '\n' : ''; // Solo agregar salto si ya hay contenido
                if (dia === 'LUNES') dias.LUNES += `${separador}${taller.taller} (${h.horaInicio}-${h.horaFinal})`;
                if (dia === 'MARTES') dias.MARTES += `${separador}${taller.taller} (${h.horaInicio}-${h.horaFinal})`;
                if (dia === 'MIÉRCOLES') dias['MIÉRCOLES'] += `${separador}${taller.taller} (${h.horaInicio}-${h.horaFinal})`;
                if (dia === 'JUEVES') dias.JUEVES += `${separador}${taller.taller} (${h.horaInicio}-${h.horaFinal})`;
              }
            }
          }
        }

        // Llenar las celdas con los horarios y aplicar formato
        const celdas = [
          { col: 'C', contenido: dias.LUNES },
          { col: 'D', contenido: dias.MARTES },
          { col: 'E', contenido: dias['MIÉRCOLES'] },
          { col: 'F', contenido: dias.JUEVES },
        ];

        celdas.forEach(({ col, contenido }) => {
          const celda = worksheet.getCell(`${col}${row}`);
          celda.value = contenido.trim();
          
          // Aplicar formato SIEMPRE (con o sin contenido)
          celda.style = {
            alignment: { 
              wrapText: true, 
              vertical: 'top',
              horizontal: 'left' 
            },
            border: {
              top: { style: 'medium' },
              bottom: { style: 'medium' },
              left: { style: 'medium' },
              right: { style: 'medium' }
            }
          };
          
          // Ajustar altura de fila si hay contenido
          if (contenido.trim()) {
            const numLineas = (contenido.match(/\n/g) || []).length + 1;
            worksheet.getRow(row).height = Math.max(20, numLineas * 15);
          }
        });

        // Formato para la celda del número (#)
        worksheet.getCell(`A${row}`).style = {
          alignment: { vertical: 'middle', horizontal: 'center' },
          border: {
            top: { style: 'medium' },
            left: { style: 'medium' },
            bottom: { style: 'medium' },
            right: { style: 'medium' }
          }
        };
        
        // Formato para la celda del nombre del alumno
        worksheet.getCell(`B${row}`).style = {
          alignment: { vertical: 'top', horizontal: 'left' },
          border: {
            top: { style: 'medium' },
            left: { style: 'medium' },
            bottom: { style: 'medium' },
            right: { style: 'medium' }
          }
        };

        row++;
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    this.descargarArchivo(buffer, 'Horarios_por_Grado.xlsx');
    if (this.$toast) this.$toast.success('Archivo de horarios generado');
  } catch (error) {
    console.error('Error al generar horarios:', error);
    if (this.$toast) this.$toast.error('Error al generar horarios');
  }
},
    
    async generarExcelTodosTalleres(ExcelJS) {
      const workbook = new ExcelJS.Workbook();
      
      for (const taller of this.talleres) {
        const alumnosData = await this.obtenerAlumnosPorTaller(taller.id);
        const gruposHorarios = this.agruparPorHorario(alumnosData, taller.id);
        
        const worksheet = workbook.addWorksheet(this.sanitizarNombreHoja(taller.descripcion));
        worksheet.pageSetup.orientation = 'landscape';
        
        let currentRow = 1;
        
        for (const grupo of gruposHorarios) {
          currentRow = this.agregarGrupoAHojaExcelJS(worksheet, grupo, taller, currentRow);
          currentRow += 3; // Espaciado entre grupos
        }
      }
      
      const buffer = await workbook.xlsx.writeBuffer();
      this.descargarArchivo(buffer, 'Lista_Asistencia_Todos_Talleres.xlsx');
    },
    
    async generarExcelTallerEspecifico(ExcelJS, idTaller) {
      const taller = this.talleres.find(t => t.id == idTaller);
      const alumnosData = await this.obtenerAlumnosPorTaller(idTaller);
      const gruposHorarios = this.agruparPorHorario(alumnosData, idTaller);
      
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Lista_Asistencia');
      worksheet.pageSetup.orientation = 'landscape';
      let currentRow = 1;
      
      for (const grupo of gruposHorarios) {
        currentRow = this.agregarGrupoAHojaExcelJS(worksheet, grupo, taller, currentRow);
        currentRow += 3; // Espaciado entre grupos
      }
      
      const buffer = await workbook.xlsx.writeBuffer();
      this.descargarArchivo(buffer, `Lista_Asistencia_${this.sanitizarNombreArchivo(taller.descripcion)}.xlsx`);
    },
    
    async obtenerAlumnosPorTaller(idTaller) {
      const params = `?idtaller=${idTaller}&page=1&pageSize=3000`;
      const response = await apiFetch(`/alumnos/ObtenerAlumnosPaginado${params}`, {
        headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await response.json();
      return data.alumnos || [];
    },
    
    agruparPorHorario(alumnos, idTallerFiltro = null) {
      const grupos = new Map();
      
      // Si se especifica filtro, obtener el nombre del taller
      let nombreTallerFiltro = null;
      if (idTallerFiltro) {
        const tallerFiltro = this.talleres.find(t => t.id == idTallerFiltro);
        nombreTallerFiltro = tallerFiltro ? tallerFiltro.descripcion : null;
      }
      
      alumnos.forEach(alumno => {
        if (alumno.talleres && alumno.talleres.length > 0) {
          alumno.talleres.forEach(taller => {
            // Si se especifica un filtro de taller, solo procesar ese taller específico
            if (nombreTallerFiltro && taller.taller !== nombreTallerFiltro) {
              return; // Saltar este taller si no coincide con el filtro
            }
            
            if (taller.horariosDias && taller.horariosDias.length > 0) {
              // Agrupar por grupo del taller (idGrupo) que garantiza mismo horario y días
              const key = `grupo_${taller.idGrupo}`;
              
              if (!grupos.has(key)) {
                // Obtener horario único (todos los horariosDias del mismo grupo tienen la misma hora)
                const horarioKey = `${taller.horariosDias[0].horaInicio}-${taller.horariosDias[0].horaFinal}`;
                
                // Obtener todos los días únicos y ordenarlos
                const diasUnicos = [...new Set(taller.horariosDias.map(h => h.Dia))];
                const ordenDias = ['Lunes', 'Martes', 'Miércoles', 'Jueves'];
                diasUnicos.sort((a, b) => ordenDias.indexOf(a) - ordenDias.indexOf(b));
                const dias = diasUnicos.join(', ');
                
                grupos.set(key, {
                  horario: horarioKey,
                  dias: dias,
                  idGrupo: taller.idGrupo,
                  nombreProfesor: taller.nombreProfesor,
                  nombreTaller: taller.taller,
                  alumnos: []
                });
              }
              
              // Verificar si el alumno ya está en este grupo para evitar duplicados
              const grupo = grupos.get(key);
              if (!grupo.alumnos.some(a => a.id === alumno.id)) {
                grupo.alumnos.push(alumno);
              }
            }
          });
        }
      });
      
      return Array.from(grupos.values());
    },
    
    agregarGrupoAHojaExcelJS(worksheet, grupo, taller, startRow) {
      let currentRow = startRow;
      
      // Solo agregar el logo en la primera hoja
      if (startRow === 1) {
        // TÍTULO: Taller (centrado en toda la fila A1:E3) - EXACTO AL DE HORARIOS
        worksheet.mergeCells('A1:E3');
        worksheet.getCell('A1').value = `TALLER: ${taller.descripcion}`;
        worksheet.getCell('A1').style = {
          font: { bold: true, size: 22, color: { argb: 'FFFFFFFF' } },
          alignment: { horizontal: 'center', vertical: 'middle' },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } }
        };

        // LOGO: Cargar e insertar logo en posición ABSOLUTA (libre, sin depender de columnas) - EXACTO AL DE HORARIOS
        try {
          fetch('/images/deportivopatria.jpg')
            .then(responseImg => {
              if (responseImg.ok) {
                return responseImg.arrayBuffer();
              }
              throw new Error('No se pudo cargar la imagen');
            })
            .then(imageBuffer => {
              const imageId = worksheet.workbook.addImage({
                buffer: imageBuffer,
                extension: 'jpg',
              });
              // Posición ABSOLUTA - cambia x (derecha) y y (abajo) libremente en píxeles
              worksheet.addImage(imageId, {
                tl: { x: 50, y: 15 }, // x=píxeles desde izquierda, y=píxeles desde arriba
                ext: { width: 80, height: 80 }, // tamaño fijo en píxeles
                editAs: 'absolute'
              });
            })
            .catch(error => {
              console.log('No se pudo cargar el logo:', error);
            });
        } catch (error) {
          console.log('No se pudo cargar el logo:', error);
        }

        // SUBTÍTULO: LISTA DE ASISTENCIA (fila 4) - EXACTO AL DE HORARIOS
        worksheet.mergeCells('A4:E4');
        worksheet.getCell('A4').value = 'LISTA DE ASISTENCIA';
        worksheet.getCell('A4').style = {
          font: { bold: true, size: 14, color: { argb: 'FFFFFFFF' } },
          alignment: { horizontal: 'center', vertical: 'middle' },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } }
        };

        // Ajustar altura de las filas de títulos - EXACTO AL DE HORARIOS
        worksheet.getRow(1).height = 30;
        worksheet.getRow(2).height = 30;
        worksheet.getRow(3).height = 30;
        worksheet.getRow(4).height = 22;
        
        currentRow = 6; // Empezar después del título principal
      }
      
      // Información del grupo (más compacta)
      worksheet.mergeCells(`A${currentRow}:N${currentRow}`);
      worksheet.getCell(`A${currentRow}`).value = `${grupo.nombreProfesor || taller.nombreMaestro || 'No asignado'} - ${grupo.dias} ${grupo.horario}`;
      worksheet.getCell(`A${currentRow}`).style = {
        font: { bold: true, size: 12, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } },
        alignment: { horizontal: 'center', vertical: 'middle' }
      };

      currentRow++;
      
    // FECHA combinando más celdas
    worksheet.mergeCells(`E${currentRow}:N${currentRow}`);
    worksheet.getCell(`E${currentRow}`).style = {
      font: { bold: true, size: 10 },
      alignment: { horizontal: 'center', vertical: 'middle' },
    };

    // (Ya no aplicamos bordes a las columnas A-D)

    currentRow++;

      
      // Usar los días del grupo directamente (ej: "Martes, Jueves")
      const diasDelGrupo = grupo.dias.split(', ').map(dia => dia.toUpperCase());
      const diasOrdenados = diasDelGrupo.sort();
      
      // Generar fechas del mes actual para los días de clases
      const fechasDelMes = this.generarFechasDelMes(diasOrdenados);
      
      // Línea vacía

      
      // Encabezados principales (compactos)
      const encabezados = ['#', 'ALUMNO', 'NIVEL Y GRADO'];
      
      // Agregar fechas como columnas de asistencia
      fechasDelMes.forEach(fecha => {
        encabezados.push(fecha.trim());
      });
      
      encabezados.forEach((encabezado, index) => {
        const col = String.fromCharCode(65 + index); // A, B, C, D, E...
        worksheet.getCell(`${col}${currentRow}`).value = encabezado;
        
        worksheet.getCell(`${col}${currentRow}`).style = {
          font: { bold: true, color: { argb: 'FFFFFFFF' } },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ff01286b' } },
          alignment: { horizontal: 'center', vertical: 'middle' }
        };
      });
      currentRow++;
      
      // Datos de alumnos (ordenados alfabéticamente)
      const alumnosOrdenados = [...grupo.alumnos].sort((a, b) => {
        return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' });
      });
      
      alumnosOrdenados.forEach((alumno, alumnoIndex) => {
        // Obtener nivel y grado del alumno
        const nivelGrado = this.obtenerNivelGradoAlumno(alumno);
        const numeroAscendente = alumnoIndex + 1;
        
        const datosAlumno = [
          numeroAscendente,
          alumno.nombre.trim(),
          nivelGrado
        ];
        
        // Agregar celdas vacías para fechas de asistencia
        fechasDelMes.forEach(() => {
          datosAlumno.push('');
        });
        
        // Datos del alumno
        datosAlumno.forEach((dato, index) => {
          const col = String.fromCharCode(65 + index);
          worksheet.getCell(`${col}${currentRow}`).value = dato;
          worksheet.getCell(`${col}${currentRow}`).style = {
            alignment: { 
              horizontal: index < 3 ? (index === 0 ? 'center' : 'left') : 'center', 
              vertical: 'middle',
              wrapText: true
            },
            border: {
              top: { style: 'medium' },
              bottom: { style: 'medium' },
              left: { style: 'medium' },
              right: { style: 'medium' }
            }
          };
        });
        
        currentRow++;
      });
      
      // Ajustar anchos de columnas automáticamente al contenido
      worksheet.columns.forEach((column, index) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: false }, (cell) => {
          const columnLength = cell.value ? cell.value.toString().length : 0;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
        });
        // Establecer ancho apropiado según el tipo de columna
        if (index === 0) {
          column.width = Math.max(4, Math.min(maxLength + 1, 8)); // Columna # más estrecha
        } else if (index === 1) {
          column.width = Math.max(15, Math.min(maxLength + 2, 35)); // Nombres de alumnos
        } else {
          column.width = Math.max(8, Math.min(maxLength + 2, 25)); // Otras columnas
        }
      });
      
      return currentRow + 2;
    },
    
    descargarArchivo(buffer, nombreArchivo) {
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombreArchivo;
      link.click();
      window.URL.revokeObjectURL(url);
    },

    
    sanitizarNombreHoja(nombre) {
      return nombre.replace(/[\\\/\*\?\[\]:]/g, '').substring(0, 31);
    },
    
    sanitizarNombreArchivo(nombre) {
      return nombre.replace(/[\\\/\*\?\[\]:<>"|]/g, '_');
    },

    // Función para generar fechas del mes según los días de clases
    generarFechasDelMes(diasClases) {
      const fechas = [];
      const hoy = new Date();
      const año = hoy.getFullYear();
      const mes = hoy.getMonth();
      
      // Obtener el último día del mes
      const ultimoDia = new Date(año, mes + 1, 0).getDate();
      
      // Mapeo de días en español a números (0 = Domingo, 1 = Lunes, etc.)
      const mapaDias = {
        'DOMINGO': 0, 'LUNES': 1, 'MARTES': 2, 'MIÉRCOLES': 3, 
        'MIERCOLES': 3, 'JUEVES': 4, 'VIERNES': 5, 'SÁBADO': 6, 'SABADO': 6
      };
      
      // Convertir días de clases a números
      const diasNumeros = diasClases.map(dia => mapaDias[dia]).filter(num => num !== undefined);
      
      // Generar fechas para cada día del mes
      for (let dia = 1; dia <= ultimoDia; dia++) {
        const fecha = new Date(año, mes, dia);
        const diaSemana = fecha.getDay();
        
        // Si este día de la semana está en los días de clases
        if (diasNumeros.includes(diaSemana)) {
          const nombreDia = Object.keys(mapaDias).find(key => mapaDias[key] === diaSemana);
          const diaFormateado = dia.toString().padStart(2, '0');
          const mesFormateado = (mes + 1).toString().padStart(2, '0');
          fechas.push(`${nombreDia} ${diaFormateado}-${mesFormateado}`);
        }
      }
      
      return fechas;
    },

    // Métodos para card de conteo de niveles
    async cargarConteoNiveles() {
      try {
        this.cargandoConteo = true;
        // Obtener todos los niveles académicos
        const responseNiveles = await apiFetch('/nivelyGrados/ObtenerListaNivelesAcademicos', {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const niveles = await responseNiveles.json();
        
        // Obtener conteo por cada nivel
        const conteoPromises = niveles.map(async (nivel) => {
          const params = `?nombre=&idnivelacademico=${nivel.id}&idgrado=&idtaller=&page=1&pageSize=1`;
          const response = await apiFetch(`/alumnos/ObtenerAlumnosPaginado${params}`, {
            headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          const data = await response.json();
          return {
            id: nivel.id,
            nivel: nivel.nivel,
            cantidad: data.total || 0
          };
        });
        
        this.conteoNiveles = await Promise.all(conteoPromises);
        
        // Ordenar por cantidad (mayor a menor)
        this.conteoNiveles.sort((a, b) => b.cantidad - a.cantidad);
        
      } catch (error) {
        console.error('Error al cargar conteo de niveles:', error);
        if (this.$toast) this.$toast.error('Error al cargar el conteo de niveles');
      } finally {
        this.cargandoConteo = false;
      }
    },
    
    calcularPorcentajeConteo(cantidad) {
      const total = this.conteoNiveles.reduce((sum, nivel) => sum + nivel.cantidad, 0);
      if (total === 0) return 0;
      return Math.round((cantidad / total) * 100);
    },
    
    filtrarPorNivel(idNivel) {
      this.filtros.idnivelacademico = idNivel;
      this.filtros.idgrado = ''; // Limpiar filtro de grado
      
      // Encontrar el nivel seleccionado
      this.nivelSeleccionado = this.conteoNiveles.find(n => n.id === idNivel);
      
      this.cargarGrados(); // Cargar grados del nivel seleccionado
      this.aplicarFiltros(); // Aplicar filtros y buscar
      
      // Mostrar conteo por grados
      this.mostrarConteoGrados = true;
      this.cargarConteoGrados();
    },
    
    // Métodos para conteo de grados
    async cargarConteoGrados() {
      if (!this.nivelSeleccionado) return;
      
      try {
        this.cargandoConteoGrados = true;
        
        // Obtener grados del nivel seleccionado
        const responseGrados = await apiFetch(`/nivelyGrados/ObtenerListaGrados?idNivelAcademico=${this.nivelSeleccionado.id}`, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const grados = await responseGrados.json();
        
        // Obtener conteo por cada grado
        const conteoPromises = grados.map(async (grado) => {
          const params = `?nombre=&idnivelacademico=${this.nivelSeleccionado.id}&idgrado=${grado.id}&idtaller=&page=1&pageSize=1`;
          const response = await apiFetch(`/alumnos/ObtenerAlumnosPaginado${params}`, {
            headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          const data = await response.json();
          return {
            id: grado.id,
            grado: grado.grado,
            cantidad: data.total || 0
          };
        });
        
        this.conteoGrados = await Promise.all(conteoPromises);
        
        // Ordenar por cantidad (mayor a menor)
        this.conteoGrados.sort((a, b) => b.cantidad - a.cantidad);
        
      } catch (error) {
        console.error('Error al cargar conteo de grados:', error);
        if (this.$toast) this.$toast.error('Error al cargar el conteo de grados');
      } finally {
        this.cargandoConteoGrados = false;
      }
    },
    
    calcularPorcentajeGrados(cantidad) {
      const totalNivel = this.conteoGrados.reduce((sum, grado) => sum + grado.cantidad, 0);
      if (totalNivel === 0) return 0;
      return Math.round((cantidad / totalNivel) * 100);
    },
    
    filtrarPorGrado(idGrado) {
      this.filtros.idgrado = idGrado;
      this.aplicarFiltros(); // Aplicar filtros y buscar
    },
    
    cerrarConteoGrados() {
      this.mostrarConteoGrados = false;
      this.conteoGrados = [];
      this.nivelSeleccionado = null;
      // Limpiar filtros de nivel y grado
      this.filtros.idnivelacademico = '';
      this.filtros.idgrado = '';
      this.cargarGrados(); // Recargar todos los grados
      this.aplicarFiltros(); // Aplicar filtros sin restricciones
    },
    
    // Métodos para detectar cambios de pantalla/visibilidad
    handleVisibilityChange() {
      if (!document.hidden) {
        // El usuario regresó a la pantalla, actualizar conteo
        setTimeout(() => {
          this.cargarConteoNiveles();
        }, 500);
      }
    },
    
    handleWindowFocus() {
      // La ventana obtuvo el foco, actualizar conteo
      setTimeout(() => {
        this.cargarConteoNiveles();
      }, 300);
    },
    
    // Métodos para detectar cambios de pantalla/visibilidad
    handleVisibilityChange() {
      if (!document.hidden) {
        // El usuario regresó a la pantalla, actualizar conteo
        setTimeout(() => {
          this.cargarConteoNiveles();
        }, 500);
      }
    },
    
    handleWindowFocus() {
      // La ventana obtuvo el foco, actualizar conteo
      setTimeout(() => {
        this.cargarConteoNiveles();
      }, 300);
    },
    
    // Métodos para detectar cambios de pantalla/visibilidad
    handleVisibilityChange() {
      if (!document.hidden) {
        // El usuario regresó a la pantalla, actualizar conteo
        setTimeout(() => {
          this.cargarConteoNiveles();
        }, 500);
      }
    },
    
    handleWindowFocus() {
      // La ventana obtuvo el foco, actualizar conteo
      setTimeout(() => {
        this.cargarConteoNiveles();
      }, 300);
    },

    // Métodos para modal de detalles
    async verDetallesAlumno(alumno) {
      try {
        // Usar directamente los datos básicos del alumno del listado
        this.alumnoDetalles = {
          id: alumno.id,
          nombre: alumno.nombre,
          nivelAcademico: alumno.nivel,
          grado: alumno.grado,
          nombreTutor: alumno.nombretutor,
          telefonoTutor: alumno.telefonotutor,
          nombreTutor2: alumno.nombretutor2,
          telefonoTutor2: alumno.telefonotutor2,
          horarios: alumno.talleres || []
        };
        
        // Debug: ver estructura de datos
        console.log('Datos del alumno para detalles:', this.alumnoDetalles);
        console.log('Horarios/talleres:', this.alumnoDetalles.horarios);
        
        this.showModalDetalles = true;
      } catch (error) {
        console.error('Error al obtener detalles del alumno:', error);
        if (this.$toast) this.$toast.error('Error al cargar detalles del alumno');
      }
    },

    cerrarModalDetalles() {
      this.showModalDetalles = false;
      this.alumnoDetalles = {};
    },

    agruparHorariosPorDiaDetalle(horariosDias) {
      const agrupados = {};
      horariosDias.forEach(horario => {
        if (!agrupados[horario.Dia]) {
          agrupados[horario.Dia] = [];
        }
        agrupados[horario.Dia].push(horario);
      });
      return agrupados;
    },

    imprimirDetalles() {
      // Agregar clase temporal al body para mejorar la impresión
      document.body.classList.add('printing');
      
      // Usar el método nativo de impresión del navegador para mejor resultado
      const contenido = document.getElementById('detallesParaImprimir');
      const ventanaImpresion = window.open('', '_blank', 'width=800,height=600');
      
      ventanaImpresion.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Ficha de Alumno - ${this.alumnoDetalles.nombre}</title>
            <style>
              /* Reset y configuración básica */
              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              
              body {
                font-family: 'Arial', sans-serif;
                font-size: 12pt;
                line-height: 1.4;
                color: #333;
                padding: 20px;
                background: white;
              }
              
              .print-header {
                text-align: center;
                margin-bottom: 2rem;
                padding-bottom: 1rem;
                border-bottom: 3px solid #007bff;
                display: block !important;
              }
              
              .institucion-info h1 {
                margin: 0;
                color: #007bff;
                font-size: 24pt;
                font-weight: bold;
                letter-spacing: 2px;
                margin-bottom: 0.5rem;
              }
              
              .institucion-info h2 {
                margin: 0.5rem 0;
                color: #495057;
                font-size: 18pt;
                font-weight: 600;
              }
              
              .fecha-impresion {
                color: #6c757d;
                font-size: 11pt;
                margin-top: 0.5rem;
              }
              
              .seccion-info {
                margin-bottom: 1.5rem;
                background: #f8f9fa;
                padding: 15px;
                border-radius: 8px;
                border-left: 4px solid #007bff;
                page-break-inside: avoid;
              }
              
              .titulo-seccion {
                margin: 0 0 1rem 0;
                color: #007bff;
                font-size: 14pt;
                font-weight: 600;
              }
              
              .datos-grid {
                display: table;
                width: 100%;
              }
              
              .dato-item {
                display: table-row;
                margin-bottom: 0.5rem;
              }
              
              .label {
                display: table-cell;
                font-weight: 600;
                color: #495057;
                font-size: 11pt;
                padding: 5px 10px 5px 0;
                width: 40%;
                vertical-align: top;
              }
              
              .valor {
                display: table-cell;
                font-size: 12pt;
                color: #212529;
                padding: 5px;
                background: white;
                border: 1px solid #dee2e6;
                border-radius: 4px;
                vertical-align: top;
              }
              
              .horarios-consolidados {
                background: white;
                border-radius: 8px;
                overflow: hidden;
                border: 2px solid #e9ecef;
                margin-bottom: 2rem;
              }
              
              .tabla-horarios-consolidada {
                width: 100%;
                border-collapse: collapse;
                margin: 0;
              }
              
              .tabla-horarios-consolidada th {
                background: #007bff;
                color: white;
                padding: 10px 8px;
                text-align: center;
                border: 1px solid #0056b3;
                font-weight: 600;
                font-size: 11pt;
              }
              
              .tabla-horarios-consolidada td {
                border: 1px solid #dee2e6;
                vertical-align: top;
                padding: 8px;
                height: 50px;
              }
              
              .nombre-taller {
                background: #f8f9fa;
                font-weight: 600;
                color: #495057;
                text-align: left;
                padding: 10px !important;
                border-right: 2px solid #007bff !important;
                width: 200px;
              }
              
              .celda-horario {
                text-align: center;
              }
              
              .horarios-dia {
                display: block;
              }
              
              .horario-item {
                background: #e7f3ff;
                color: #0056b3;
                padding: 3px 6px;
                border-radius: 4px;
                font-size: 10pt;
                font-weight: 600;
                border: 1px solid #b3d9ff;
                margin-bottom: 3px;
                display: block;
              }
              
              .sin-horario {
                color: #6c757d;
                font-style: italic;
                font-size: 10pt;
              }
              
              .sin-talleres {
                text-align: center;
                padding: 2rem;
                color: #6c757d;
                font-style: italic;
                background: #f8f9fa;
                border-radius: 8px;
                border: 2px dashed #dee2e6;
              }
              
              @page {
                margin: 1cm;
              }
              
              @media print {
                body {
                  padding: 0;
                }
                .no-print {
                  display: none !important;
                }
              }
            </style>
          </head>
          <body>
            ${contenido.innerHTML}
          </body>
        </html>
      `);
      
      ventanaImpresion.document.close();
      ventanaImpresion.focus();
      
      // Esperar a que cargue completamente y luego imprimir
      setTimeout(() => {
        ventanaImpresion.print();
        
        // Remover clase temporal después de imprimir
        setTimeout(() => {
          document.body.classList.remove('printing');
          ventanaImpresion.close();
        }, 1000);
      }, 750);
      
      // Fallback para remover la clase en caso de error
      setTimeout(() => {
        document.body.classList.remove('printing');
      }, 5000);
    },

    obtenerHorariosPorDia(horariosDias, diaTarget) {
      if (!horariosDias) return [];
      return horariosDias.filter(h => h.Dia === diaTarget);
    }
  },
  mounted() {
    this.fetchNiveles();
    this.fetchTalleres();
    this.buscarAlumnos();
    
    // Configurar scroll horizontal con rueda del mouse
    this.$nextTick(() => {
      const tablaResponsive = document.querySelector('.tabla-responsive');
      if (tablaResponsive) {
        // Scroll horizontal con rueda del mouse
        tablaResponsive.addEventListener('wheel', (e) => {
          // Si hay scroll horizontal disponible
          if (tablaResponsive.scrollWidth > tablaResponsive.clientWidth) {
            e.preventDefault();
            // Convertir scroll vertical en horizontal
            tablaResponsive.scrollLeft += e.deltaY;
          }
        }, { passive: false });

        // Drag para desplazar (opcional)
        let isDown = false;
        let startX;
        let scrollLeft;

        tablaResponsive.addEventListener('mousedown', (e) => {
          isDown = true;
          startX = e.pageX - tablaResponsive.offsetLeft;
          scrollLeft = tablaResponsive.scrollLeft;
          tablaResponsive.style.cursor = 'grabbing';
        });

        tablaResponsive.addEventListener('mouseleave', () => {
          isDown = false;
          tablaResponsive.style.cursor = 'grab';
        });

        tablaResponsive.addEventListener('mouseup', () => {
          isDown = false;
          tablaResponsive.style.cursor = 'grab';
        });

        tablaResponsive.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - tablaResponsive.offsetLeft;
          const walk = (x - startX) * 2;
          tablaResponsive.scrollLeft = scrollLeft - walk;
        });
      }
    });
  }
};
</script>

<style scoped>
/* Estilos responsivos para el card de conteo */
.conteo-niveles-card {
  transition: all 0.3s ease;
}

.niveles-grid-conteo {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.nivel-conteo-item {
  transition: all 0.3s ease;
}

/* Estilos para el card de conteo por grados */
.conteo-grados-card {
  transition: all 0.3s ease;
}

.grados-grid-conteo {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.grado-conteo-item {
  transition: all 0.3s ease;
}

.nivel-conteo-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
}

/* Animación de pulso para el indicador de carga */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Responsivo para móviles */
@media (max-width: 768px) {
  .conteo-niveles-card {
    margin: 1rem 0.5rem !important;
    padding: 1rem !important;
    border-radius: 8px !important;
  }
  
  .niveles-grid-conteo {
    grid-template-columns: 1fr !important;
    gap: 0.8rem !important;
  }
  
  .nivel-conteo-item {
    padding: 1rem !important;
  }
  
  .conteo-niveles-card h3 {
    font-size: 1.1rem !important;
    margin-bottom: 1rem !important;
  }
}

@media (max-width: 480px) {
  .conteo-niveles-card {
    margin: 1rem 0.2rem !important;
    padding: 0.8rem !important;
  }
  
  .nivel-conteo-item {
    padding: 0.8rem !important;
  }
  
  .conteo-niveles-card h3 {
    font-size: 1rem !important;
  }
}

.modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  box-sizing: border-box;
  overflow-y: auto;
}

@media (max-width: 500px) {
  .modal {
    padding: 0;
    align-items: flex-start;
  }
}
.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 901px) {
  .modal-content {
    min-width: 800px;
    width: 800px;
  }
}

@media (max-width: 900px) {
  .modal-content {
    width: 98vw !important;
    padding: 1rem !important;
    margin: 1rem !important;
  }
}

@media (max-width: 500px) {
  .modal-content {
    width: 100vw !important;
    padding: 0.8rem !important;
    margin: 0 !important;
    border-radius: 0 !important;
    max-height: 100vh !important;
  }
}
.modal-content label {
  display: block;
  margin-top: 1rem;
}
.modal-content input, .modal-content select {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-content button {
  margin-top: 1.2rem;
}

/* --- ESTILOS RESPONSIVOS TABLA PRINCIPAL --- */
.tabla-responsive {
  width: 100% !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 8px;
  /* Forzar scroll horizontal SIEMPRE */
  max-width: 100vw !important;
  display: block !important;
  position: relative;
  /* Scrollbar más grande y visible */
  scrollbar-width: auto;
  scrollbar-color: #4a90e2 #e0e0e0;
  /* Cursor que indica que se puede desplazar */
  cursor: grab;
}

.tabla-responsive:active {
  cursor: grabbing;
}

/* Scrollbar personalizado para webkit */
.tabla-responsive::-webkit-scrollbar {
  height: 12px;
}
.tabla-responsive::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 6px;
}
.tabla-responsive::-webkit-scrollbar-thumb {
  background: #4a90e2;
  border-radius: 6px;
  border: 2px solid #e0e0e0;
}
.tabla-responsive::-webkit-scrollbar-thumb:hover {
  background: #357abd;
}

/* Indicador visual de scroll */
.tabla-responsive::after {
  content: "← Desplázate horizontalmente →";
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #666;
  font-style: italic;
  pointer-events: none;
  opacity: 0.7;
}

/* Ocultar indicador en pantallas grandes */
@media (min-width: 1201px) {
  .tabla-responsive::after {
    display: none;
  }
}

.tabla-alumnos-principal {
  width: 1200px !important; /* Ancho fijo SIEMPRE */
  border-collapse: collapse;
  min-width: 1200px !important;
  max-width: none !important;
  border-radius: 8px;
  overflow: visible;
  background: #fff;
  margin: 0;
  /* Asegurar que la tabla mantenga su ancho fijo */
  table-layout: fixed !important;
  display: table !important;
}

.tabla-alumnos-principal th {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1rem;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
  border: none;
  white-space: nowrap;
}

.tabla-alumnos-principal td {
  padding: 0.8rem;
  font-size: 1rem;
  border-bottom: 1px solid #e9ecef;
  background: #fff;
  color: #333;
  vertical-align: middle;
}

.tabla-alumnos-principal td:first-child {
  font-weight: 600; /* Nombre en negrita */
  text-align: left;
  min-width: 200px;
}

.tabla-alumnos-principal td:nth-child(2), 
.tabla-alumnos-principal td:nth-child(3) {
  text-align: center;
  min-width: 100px;
}

.tabla-alumnos-principal td:nth-child(4) {
  text-align: left;
  min-width: 200px;
}

.tabla-alumnos-principal td:nth-child(5) {
  text-align: left;
  min-width: 300px;
}

.tabla-alumnos-principal td:last-child {
  text-align: center;
  min-width: 200px;
}
/* --- FIN ESTILOS RESPONSIVOS TABLA PRINCIPAL --- */

/* --- ESTILOS MODAL DETALLES MEJORADO --- */
.detalles-modal {
  max-width: 900px !important;
  width: 95vw !important;
  max-height: 95vh !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  border-radius: 16px !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  /* Scroll suave y visible */
  scrollbar-width: auto;
  scrollbar-color: #007bff #e9ecef;
}

.detalle-contenido {
  padding: 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-width: 800px; /* Ancho mínimo para scroll horizontal */
  overflow-x: auto;
  overflow-y: visible;
}

.print-header {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  padding: 2rem;
  text-align: center;
  margin: -2rem -2rem 2rem -2rem;
}

.print-header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.print-header h2 {
  margin: 0.5rem 0 0 0;
  font-size: 1.2rem;
  font-weight: 400;
  opacity: 0.9;
}

.fecha-impresion {
  margin-top: 1rem;
  font-size: 0.9rem;
  opacity: 0.8;
}

.info-alumno {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  margin: 1rem 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .info-alumno {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

.seccion-info {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 10px;
  border-left: 4px solid #007bff;
}

.titulo-seccion {
  margin: 0 0 1.5rem 0;
  color: #495057;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #dee2e6;
}

.datos-grid {
  display: grid;
  gap: 1rem;
}

.dato-item {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 0.5rem;
  align-items: center;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}

.dato-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.label {
  font-weight: 600;
  color: #6c757d;
  font-size: 0.9rem;
}

.valor {
  font-weight: 500;
  color: #212529;
  background: #f8f9fa;
  padding: 0.5rem;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

.seccion-horarios {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  margin: 1rem 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.tabla-horarios-consolidada {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.tabla-horarios-consolidada th {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  padding: 1rem;
  font-weight: 600;
  text-align: center;
  border: none;
  font-size: 0.95rem;
}

.tabla-horarios-consolidada td {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  vertical-align: top;
  transition: background-color 0.2s ease;
}

.tabla-horarios-consolidada tr:hover td {
  background-color: #f8f9fa;
}

.nombre-taller {
  font-weight: 600;
  color: #007bff;
  background-color: #f8f9fa !important;
  border-right: 2px solid #007bff;
}

.celda-horario {
  text-align: center;
}

.horarios-dia {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.horario-item {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.sin-horario {
  color: #6c757d;
  font-style: italic;
  opacity: 0.7;
}

.sin-talleres {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  margin: 1rem 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.sin-talleres p {
  color: #6c757d;
  font-size: 1.1rem;
  margin: 0;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1.5rem;
  margin-top: 1.5rem;
  border-top: 2px solid #dee2e6;
}

.btn-imprimir, .btn-cerrar {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-imprimir {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.btn-imprimir:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.btn-cerrar {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
}

.btn-cerrar:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
}

@media (max-width: 768px) {
  .detalles-modal {
    width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
  }
  
  .info-alumno {
    padding: 1rem;
  }
  
  .dato-item {
    grid-template-columns: 1fr;
    text-align: left;
  }
  
  .tabla-horarios-consolidada {
    font-size: 0.8rem;
  }
  
  .tabla-horarios-consolidada th,
  .tabla-horarios-consolidada td {
    padding: 0.5rem;
  }
}

/* --- SCROLLBARS PERSONALIZADOS PARA MODAL DETALLES --- */
.detalles-modal::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.detalles-modal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.detalles-modal::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-radius: 6px;
  border: 2px solid #f1f1f1;
}

.detalles-modal::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
}

.detalles-modal::-webkit-scrollbar-corner {
  background: #f1f1f1;
}

.detalle-contenido::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.detalle-contenido::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.detalle-contenido::-webkit-scrollbar-thumb {
  background: rgba(0, 123, 255, 0.6);
  border-radius: 4px;
}

.detalle-contenido::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 123, 255, 0.8);
}

/* Indicadores de scroll */
.detalles-modal::before {
  content: "↕ Desplázate verticalmente | ↔ Desplázate horizontalmente";
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  z-index: 10000;
  pointer-events: none;
  animation: fadeInOut 4s ease-in-out;
}

@keyframes fadeInOut {
  0%, 100% { opacity: 0; }
  20%, 80% { opacity: 1; }
}

/* Mejorar el área de scroll de la tabla */
.tabla-horarios-consolidada {
  width: 100%;
  min-width: 600px; /* Ancho mínimo para activar scroll horizontal */
  border-collapse: collapse;
  margin-top: 1rem;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Contenedor de tabla con scroll */
.horarios-consolidados {
  overflow-x: auto;
  overflow-y: visible;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.horarios-consolidados::-webkit-scrollbar {
  height: 8px;
}

.horarios-consolidados::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.horarios-consolidados::-webkit-scrollbar-thumb {
  background: #007bff;
  border-radius: 4px;
}

/* Ajustes responsivos para scroll */
@media (max-width: 768px) {
  .detalles-modal {
    width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
  }
  
  .detalle-contenido {
    min-width: 100%;
    padding-right: 1rem;
  }
  
  .info-alumno {
    padding: 1rem;
    min-width: 600px; /* Para activar scroll horizontal en móvil */
  }
  
  .tabla-horarios-consolidada {
    min-width: 500px;
    font-size: 0.8rem;
  }
  
  .detalles-modal::before {
    bottom: 10px;
    right: 10px;
    font-size: 0.7rem;
    padding: 0.3rem 0.8rem;
  }
}

/* --- ESTILOS DE IMPRESIÓN PARA DETALLES --- */
@media print {
  /* Ocultar elementos que no se deben imprimir */
  .no-print,
  .modal {
    display: none !important;
  }
  
  /* Mostrar solo el contenido para impresión */
  #detallesParaImprimir {
    display: block !important;
    position: static !important;
    width: 100% !important;
    height: auto !important;
    background: white !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
  }
  
  /* Ajustar el header para impresión - MÁS COMPACTO */
  .print-header {
    background: #007bff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color: white !important;
    padding: 0.8rem !important;
    margin: 0 0 0.5rem 0 !important;
    flex-shrink: 0 !important;
  }
  
  .print-header h1 {
    font-size: 1.3rem !important;
    margin: 0 !important;
    color: white !important;
  }
  
  .print-header h2 {
    font-size: 0.9rem !important;
    margin: 0.2rem 0 0 0 !important;
    color: white !important;
  }
  
  .fecha-impresion {
    font-size: 0.7rem !important;
    margin-top: 0.2rem !important;
  }
  
  /* Ajustar información del alumno - MÁS COMPACTA */
  .info-alumno {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 0.5rem !important;
    background: white !important;
    padding: 0 !important;
    margin: 0.3rem 0 !important;
    box-shadow: none !important;
    flex-shrink: 0 !important;
  }
  
  .seccion-info {
    background: #f8f9fa !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    padding: 0.5rem !important;
    margin: 0 !important;
    border: 1px solid #007bff !important;
    border-radius: 4px !important;
  }
  
  .titulo-seccion {
    color: #007bff !important;
    font-size: 0.8rem !important;
    font-weight: bold !important;
    margin: 0 0 0.3rem 0 !important;
    border-bottom: 1px solid #dee2e6 !important;
    padding-bottom: 0.2rem !important;
  }
  
  .datos-grid {
    display: block !important;
    font-size: 0.7rem !important;
  }
  
  .dato-item {
    display: flex !important;
    align-items: center !important;
    margin-bottom: 0.2rem !important;
    padding: 0.2rem !important;
    background: white !important;
    border: none !important;
    border-radius: 2px !important;
  }
  
  .label {
    font-weight: bold !important;
    color: #495057 !important;
    min-width: 40% !important;
    margin-right: 0.3rem !important;
  }
  
  .valor {
    color: #212529 !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    font-weight: normal !important;
    flex: 1 !important;
  }
  
  /* Ajustar sección de horarios - MÁS COMPACTA */
  .seccion-horarios {
    background: white !important;
    padding: 0 !important;
    margin: 0.3rem 0 !important;
    box-shadow: none !important;
    flex: 1 !important;
    overflow: hidden !important;
  }
  
  .tabla-horarios-consolidada {
    width: 100% !important;
    min-width: 0 !important;
    border-collapse: collapse !important;
    margin: 0 !important;
    font-size: 0.65rem !important;
  }
  
  .tabla-horarios-consolidada th {
    background: #007bff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color: white !important;
    padding: 0.3rem 0.2rem !important;
    border: 1px solid #007bff !important;
    font-weight: bold !important;
    font-size: 0.65rem !important;
  }
  
  .tabla-horarios-consolidada td {
    padding: 0.2rem 0.1rem !important;
    border: 1px solid #dee2e6 !important;
    background: white !important;
    vertical-align: top !important;
    max-height: 60px !important;
    overflow: hidden !important;
  }
  
  .nombre-taller {
    background: #f8f9fa !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color: #007bff !important;
    font-weight: bold !important;
    border-right: 2px solid #007bff !important;
    font-size: 0.6rem !important;
    max-width: 120px !important;
    word-wrap: break-word !important;
  }
  
  .horario-item {
    background: #28a745 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color: white !important;
    padding: 0.1rem 0.2rem !important;
    border-radius: 2px !important;
    font-size: 0.55rem !important;
    margin-bottom: 0.1rem !important;
    display: block !important;
    line-height: 1.2 !important;
  }
  
  .sin-horario {
    color: #6c757d !important;
    text-align: center !important;
    font-size: 0.6rem !important;
  }
  
  /* Ajustar mensaje sin talleres */
  .sin-talleres {
    background: #f8f9fa !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    padding: 1rem !important;
    text-align: center !important;
    border: 2px solid #6c757d !important;
    border-radius: 8px !important;
    margin: 1rem 0 !important;
  }
  
  .sin-talleres p {
    color: #6c757d !important;
    margin: 0 !important;
  }
  
  /* Configuración de página - UNA SOLA HOJA */
  @page {
    margin: 1cm;
    size: A4;
  }
  
  /* Forzar que todo el contenido quepa en una página */
  #detallesParaImprimir {
    height: 100vh !important;
    max-height: 100vh !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
    transform: scale(0.9) !important;
    transform-origin: top left !important;
    width: 111% !important;
  }
  
  /* Evitar cortes de página en elementos importantes */
  .seccion-info,
  .tabla-horarios-consolidada,
  .sin-talleres {
    page-break-inside: avoid !important;
  }
  
  /* Ocultar scrollbars en impresión */
  * {
    overflow: visible !important;
  }
}

/* Estilos específicos para el contenido de impresión cuando se activa */
body.printing #detallesParaImprimir {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background: white !important;
  z-index: 9999 !important;
  overflow-y: auto !important;
  padding: 1rem !important;
}

body.printing .modal,
body.printing .no-print {
  display: none !important;
}

/* --- ESTILOS TABLA MODAL LISTA ASISTENCIA --- */
.tabla-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin: 1rem 0;
}

.tabla-alumnos-modal {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 0.9rem;
}

.tabla-alumnos-modal th {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #0056b3;
  position: sticky;
  top: 0;
  z-index: 10;
}

.tabla-alumnos-modal td {
  padding: 14px 16px;
  border-bottom: 1px solid #f1f3f4;
  vertical-align: top;
  line-height: 1.5;
}

.tabla-alumnos-modal tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

.nombre-alumno {
  font-weight: 600;
  color: #2c3e50;
  min-width: 200px;
  font-size: 0.95rem;
}

.talleres-alumno {
  width: 60%;
}

.taller-item {
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.taller-item:last-child {
  margin-bottom: 0;
}

.taller-nombre {
  display: block;
  font-weight: 600;
  color: #007bff;
  margin-bottom: 6px;
  font-size: 0.9rem;
}

.horarios-taller {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.horario-tag {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid #bbdefb;
}

.sin-datos {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-style: italic;
  background: #f8f9fa;
}

/* --- FIN ESTILOS TABLA MODAL LISTA ASISTENCIA --- */

/* --- ESTILOS MODALES ESTANDARIZADOS --- */

/* Estilos para el header del modal */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e1e5e9;
  padding-bottom: 1rem;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
}

/* Botón de cerrar (X) */
.close-btn {
  background: none;
  border: none;
  font-size: 1.1rem;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

/* Responsivo para el botón de cerrar */
@media (max-width: 768px) {
  .close-btn {
    width: 20px;
    height: 20px;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .close-btn {
    width: 18px;
    height: 18px;
    font-size: 0.9rem;
  }
}

.close-btn:hover {
  background-color: #f5f5f5;
  color: #666;
}

.close-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);
}

/* Container para botones del modal */
.modal-buttons {
  display: flex;
  gap: 0.75rem;
  padding: 1.5rem;
  border-top: 1px solid #e1e5e9;
  background-color: #f8f9fa;
  margin-top: 1.5rem;
  justify-content: flex-end;
}

/* Botones estandarizados */
.btn-primary {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.5rem 1.2rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 0.9rem;
}

.btn-primary:hover {
  background: #5a6268;
}

.btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.3);
}

.btn-secondary {
  background: #e9ecef;
  color: #495057;
  border: 1px solid #ced4da;
  padding: 0.5rem 1.2rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.btn-secondary:hover {
  background: #dee2e6;
  border-color: #adb5bd;
}

.btn-secondary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.15);
}

/* Estilos para la columna de nivel y grado académico */
.numero-alumno {
  text-align: center;
  padding: 0.8rem 0.5rem;
  vertical-align: middle;
  font-weight: 700;
  color: #495057;
  background-color: #f8f9fa;
  width: 50px;
}

.nivel-grado-academico {
  text-align: center;
  padding: 0.8rem 0.5rem;
  vertical-align: middle;
}

.nivel-grado-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* --- FIN ESTILOS MODALES ESTANDARIZADOS --- */

/* --- FIN ESTILOS MODAL DETALLES MEJORADO --- */
</style>
